import React, { useContext, useEffect, useState, useRef } from 'react';
import {
  ClientDataSearchColumn, ClientDataSearchError, ClientDataButtoCalculate, ClientDataAddButton, ClientDataButtoCalculateButton,
  ClientDataTotal, ClientDataTotalPrice, ClientDataTotalTitle, ClientDataMontoTotal, ClientDataTotalData, ClientDataTotalDataMin,
  ClientDataTotalDataMinBlack, InfoCircleImage, Tooltip, TooltipContent, TooltipTitle, ClientDataHead, ClientDataHeadLabel
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { SessionContext, SimulatorContext } from '../../../store';
import { currencyMoney } from '../../../config/currency';
import { getTasas, getTasasFilter, getTasasPricing, getTasasPricingAndCifin, isPricing } from '../../../services/tasas';
import { getPaymentBill } from '../../../services/paymentbill';
import { getStates } from '../../../services/states';
import { handleChangeIdentification } from '../../../helpers/price';
import { default as SimulatorTypes } from '../../../store/Simulator/types';
import Select from '../../../components/Select';
import InputDefault from '../../../components/InputDefault';
import InputIntl from '../../../components/InputIntl';
import RadioButtonForm from '../../../components/RadioButtonForm';
import { simulatorSteps } from '../../../helpers/enum';
import { DefaultSmallButton, SecondaryLargeButton, DefaultSmallButtonBuscar } from '../../../components/Buttons/styles';
import FormTemplate from '../../../components/FormTemplate';
import { Form, FormRow, FormFooter, FormRow3Columns, FormRowInvisible, FormFooterRigth, FormRowBorder } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/Loader';
import SearchField from '../../../components/SearchField';
import { identificationType } from '../../../helpers/enum';
import { getClientDataFull, getClientDataFullWithOutModal } from '../../../services/clients';
import { getLastCreditByClient } from '../../../services/credit';
import { clientRegistrationSteps } from '../../../helpers/enum';
import { getCities } from "../../../services/cities";
import { formatPrice } from '../../../helpers/price';
import { postGestionPoliticas, postSimulation, postSimulationPricing } from '../../../services/simulation';
import { credits, creditLinesBack, CreditDestination, CreditDestinationSelect } from '../../../helpers/enum';
import { getCreditsByAdvisor } from '../../../services/credit';
import colors from '../../../assets/styles/colors';
import { BsExclamation } from 'react-icons/bs';
import { saveSimulationResult } from '../../../services/simulation';
import InputCheckbox from '../../../components/InputCheckbox';
import {
  FinancesDataTotal,
  FinancesDataTotalTitle,
  FinancesDataTotalPrice,
  FinancesDataButtoCalculate,
  FinancesDataButtoCalculateButton,
  FinancesDataCreditLine,
  FinancesDataCreditLineTitle,
  FinancesDataCreditCheckboxContainer,
  FinancesDataCreditCheckboxContainerLine,
  FinancesDataCreditCheckboxContainerText,
  FinancesDataCreditCheckboxContainerTitle,
  FinancesDataCreditCheckboxContainerSaldo,
  FinancesDataAddButton,
  FinancesDataFieldContent,
  FinancesDataFieldInputTitle,
  FinancesDataFieldTitle,
  FinancesDataFieldTitleValorLabel,
  FinancesDataFieldTitleValorDeleteItem,
  FinancesDataFieldContainer,
  FinancesDataTotalFieldsCredits,
  FinancesDataTotalFieldsCreditsLabel,
  FinancesDataTotalFieldsCreditsValue,
  SaldoTotalRecoger,
  SaldoTotalRecogerContainer,
  FinancesDataNoCredit
} from '../FinancesData/styles';
import {
  StepFourContainer,
  StepFourHeader,
  StepFourHeaderTitle,
  StepFourHeaderStep,
  StepFourHeaderInfo,
  StepFourButtonSimulation,
  StepFourContent,
  StepFourColumn,
  StepFourResultItem,
  StepFourResultItemIcon,
  StepFourResultItemInfo,
  StepFourDisplayResultLabel,
  StepFourDisplayValues,
  StepFourDisplayValuesRow,
  StepFourDisplayValuesRowValue,
  StepFourFooter,
  StepFourFooterLeftSide,
  StepFourFooterRightSide,
  StepFourResultBigItemIcon,
} from '../Result/styles';
import ModalInfo from '../../../components/ModalInfo';
import Buscar from '../../../assets/images/buscar.svg';
import InputDate from '../../../components/InputDate';
import { calculateDate } from '../../../helpers/date';
import { getEducational } from '../../../services/educational';
import { getContractTypes, getExtracts } from '../../../services/extract';
import infoCircle from '../../../assets/images/info-circle.svg';
import { getActivities, getActivitiesPorIdPagaduria } from '../../../services/actividades';
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import Slider from '../../../components/SliderCurrency';
import SliderInt from '../../../components/SliderInt';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { H5, H6 } from '../../../components/Typography/styles';
import { BsChevronBarUp, BsCheck, BsInfo, BsPersonCheck, BsBoxArrowUpRight } from 'react-icons/bs';
import { IoWalletOutline } from 'react-icons/io5';
import { BiBasket } from 'react-icons/bi';
import { DefaultLargeButton, TertiaryLargeButton } from '../../../components/Buttons/styles';
import singPost from '../../../assets/images/signPost.svg';
import { getPiloto } from '../../../services/desk';
import { validateClientAdvisorPaymentBill, valideteClientAdvisor, valideteClientAdvisorWithoutModal } from '../../../services/clientRegistration';
import { getGenders, getIdentificationTypes, getPaisesMundo, getSpecialConditions } from '../../../services/calculator';
import { getLineasDeCredito, postCalcularBonoSocial, postIsBonoSocial } from '../../../services/lineasDeCredito';
import { postGenerateAutorization } from '../../../services/habeasData';
import ModalAction from '../../../components/ModalAction';


const PriceValueToSolicitatePage = ({ setActiveStep, setLastStep, setShowModal }) => {
  const { simulator, setSimulator } = useContext(SimulatorContext);
  const session = useContext(SessionContext);
  const { register, handleSubmit, setValue, watch, control, clearErrors, errors } = useForm({ defaultValues: simulator.priceValueToSolicitate });
  const [isLoading, setIsLoading] = useState(false);
  const [tasas, setTasas] = useState([]);
  const [showTasa, setShowTasa] = useState(false);
  const [calculate, setCalculate] = useState(true);
  const [valorTea, setValorTea] = useState(0.00);
  const [paymentBill, setPaymentBill] = useState([]);
  const [filteredPaymentBill, setFilteredPaymentBill] = useState([]);
  const [showPaymentBill, setShowPaymentByll] = useState(false);
  const [showState, setShowState] = useState(false);
  const [showCity, setShowCity] = useState(false);
  const [showElement, setShowElement] = useState(false);
  const [states, setStates] = useState([]);
  const [disabledForm, setDisabledForm] = useState(true);
  const [titleErrorOnCalculate, setTitleErrorOnCalculate] = useState('');
  const [titleErrorIngresos, setTitleErrorIngresos] = useState('');
  const [showLineOfCredit, setShowLineOfCredit] = useState(false);
  const [creditsByAcesor, setCreditsByAcesor] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [totalFieldsCredit, setTotalFieldsCredit] = useState(0);
  const [isCreditsByAcesor, setIsCreditsByAcesor] = useState(false);
  const [messageErrorOnCalculate, setMessageErrorOnCalculate] = useState('');
  const [clientDataSearchIdentificationType, setClientDataSearchIdentificationType] = useState("");
  const [clientDataSearchIdentification, setClientDataSearchIdentification] = useState("");
  const [clientDataSearchError, setClientDataSearchError] = useState("");
  const [clientDataSearchErrorVisible, setClientDataSearchErrorVisible] = useState("");
  const fields = watch();
  const [showModalInfoIngresos, setShowModalInfoIngresos] = useState(false);
  const [showModalInfoError, setShowModalInfoError] = useState(false);
  const [showEducationalLevel, setShowEducationalLevel] = useState(false);
  const [showContractType, setShowContractType] = useState(false);
  const [educationalLevel, setEducationalLevel] = useState([]);
  const [contractTypes, setContractsType] = useState([]);
  const [showExtracts, setShowExtracts] = useState(false);
  const [extracts, setExtracts] = useState([]);
  const [showError, setShowError] = useState(false);
  const [simulatorOne, setSimulatorOne] = useState(true);
  const [showModalInfoProduct, setShowModalInfoProduct] = useState(false);
  const [messageErrorProduct, setMessageErrorProduct] = useState('');
  const [titleErrorProduct, setTitleErrorProduct] = useState('');
  const [valorTea1, setValorTea1] = useState(0.00);
  const [showActivity, setShowActivity] = useState(false);
  const [activities, setActivities] = useState([]);
  const [showModalNullContract, setShowModalNullContract] = useState(false);
  const [showClientData, setShowClientData] = useState(true);
  const [tipoDocumento, setTipoDocumentos] = useState([]);
  const [showTipoDocumentos, setShowTipoDocumentos] = useState(false);
  const [showModalPlazo, setShowModalPlazo] = useState(false);
  const [pilotoPagaduria, setPilotoPagaduria] = useState(false);
  const [gestionPoliticasMessage, setGestionPoliticasMessage] = useState('');
  const [gestionPoliticas, setGestionPoliticas] = useState(false);
  const [nuevoProductoLibranzas, setNuevoProductoLibranzas] = useState(false);
  const [invalidClient, setInvalidClient] = useState(false);
  const [idPagadurias, setIdPagadurias] = useState(-1);
  const [generos, setGeneros] = useState([]);
  const [showGeneros, setShowGeneros] = useState(false);
  const [showPais, setShowPais] = useState(false);
  const [paises, setPaises] = useState([]);
  const [filteredPais, setFilteredPais] = useState([]);
  const [showDepartamento, setShowDepartamento] = useState(false);
  const [departamentos, setDepartamentos] = useState([]);
  const [filteredDepartamento, setFilteredDepartamento] = useState([]);
  const [showCiudad, setShowCiudad] = useState(false);
  const [ciudades, setCiudades] = useState([]);
  const [filteredCiudad, setFilteredCiudad] = useState([]);
  const [anotherDeparment, setAnotherDeparment] = useState(false);
  const [anotherCity, setAnotherCity] = useState(false);
  const [anotherCountry, setAnotherCountry] = useState(false);
  const [lineasDeCredito, setLineasDeCredito] = useState([]);
  const [piloto, setPiloto] = useState([]);
  const [showModalBonoSocial, setShowModalBonoSocial] = useState(false);
  const [lineasDeCreditoBD, setLineasDeCreditoBD] = useState([]);
  const [tittleModalBonoSocial, setTittleModalBonoSocial] = useState('');
  const [montoSolicitadoBD, setMontoSolicitadoBD] = useState(2000000);
  const [capacidadCliente, setCapacidadCliente] = useState(0);
  const [showSlider, setShowSlider] = useState(true);
  const [showModalCambioAsesor, setShowModalCambioAsesor] = useState(false);
  const [showModalCambioAsesorEnviado, setShowModalCambioAsesorEnviado] = useState(false);
  const [errores, setErrores] = useState([]);
  const isExecuting = useRef(false);

  async function initializedStateComponent() {
    try {
      setIsLoading(true);
      //setSelectedPais({id: 18, nombre: "Colombia", codificacionDeceval: "14", codificacionDane: "CO"});
      setInitiarDiasIniciales();
      setPlazoInicial();
      setMontoSolicitado();
      setIdentificationRadioChecked({ id: 'CC', nombre: 'Cédula de ciudadanía', label: 'CC', value: 'CC' });
      const isPricingResponse = await isPricing(simulator.desk.id);
      const isPilotoPagaduria = await getPiloto(simulator.desk.id);
      const identificationTypes = await getIdentificationTypes();
      const genders = await getGenders();
      const paises = await getPaisesMundo();
      setPaises(paises.data)
      setTipoDocumentos(identificationTypes.data);
      setGeneros(genders.data);
      setPilotoPagaduria(isPilotoPagaduria.data.isModeloPagaduria);
      setPiloto(isPilotoPagaduria.data);
      const lineasCredito = await getLineasDeCredito();
      setLineasDeCreditoBD(lineasCredito.data)
      setLineasDeCredito(lineasCredito.data);
      if (!isPilotoPagaduria.data.isModeloPagaduria) {
        const activities = await getActivities();
        await setActivities(activities.data);
        if (simulator.clientData.actividadCliente) {
          const actividad = activities.data.find(item => item.id === simulator.clientData.actividadCliente?.id);
          setSelectedActivitie(actividad);
        }
      }

      if (!isPricingResponse.data) {
        const tasas = await getTasas();
        await setTasas(tasas.data);
        const tasa = tasas.data.find(item => (item.id === simulator.priceValueToSolicitate.tasa.id || item.id == simulator.priceValueToSolicitate.tasa));
        await setSelectedTasa(tasa);
      }

      const paymentBill = await getPaymentBill();
      const states = await getStates();
      const educationalLevelReponse = await getEducational();
      const extractResponse = await getExtracts();



      if (simulator.clientData.estrato) {
        extractResponse.data.map((item) => {
          if (item.nombre == simulator.clientData.estrato) {
            selectExtract(item);
          }
        });
      }

      if (simulator.clientData.departamento) {
        states.data.map((item) => {
          if (item.id == simulator.clientData.departamento) {
            setSelectedState(item);
          }
        });
      }

      if (simulator.priceValueToSolicitate.nivelEscolaridad) {
        educationalLevelReponse.data.map((item) => {
          if (item.idLegado === simulator.priceValueToSolicitate.nivelEscolaridad) {
            selectEducationalLevel(item);
          }
        });
      }

      if (simulator.clientData.genero) {
        setValue("genero", simulator.clientData.genero)
      }
      if (simulator.financesData.ingresos) {
        setValue("ingresos", simulator.financesData.ingresos)
      }
      if (simulator.financesData.descuentosLey) {
        setValue("descuentosLey", simulator.financesData.descuentosLey)
      }

      await setEducationalLevel(educationalLevelReponse.data);
      await setExtracts(extractResponse.data);
      await setStates(states.data);
      setPaymentBill(paymentBill.data);
      setDisabledForm(true);
      autoCompleteData();
      if(simulator.priceValueToSolicitate.capacidadCliente){
        setValue("capacidadCliente", simulator.priceValueToSolicitate.capacidadCliente);
        setCapacidadCliente(simulator.priceValueToSolicitate.capacidadCliente);
        setShowSlider(false);
        setShowSlider(true);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error.response)
    }
  }

  function autoCompleteData() {
    if (simulator.clientData.fechaNacimiento) {
      setValue("fechaNacimiento", simulator.clientData.fechaNacimiento)
      let years = calculateDate(simulator.clientData.fechaNacimiento);
      setValue("edad", years);
      setSimulator({
        type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
        edad: years
      })
    }
    if (simulator.clientData.identificacion) {
      setValue("identificacion", simulator.clientData.identificacion)
    }
  }

  /*useEffect(() => {
    if (simulator.desk.id) {
      ispricing();
    }
  }, [simulator.desk.id]);

  async function ispricing() {
    const isPricingResponse = await isPricing(simulator.desk.id);
    await setSimulator({
      type: SimulatorTypes.SET_PRICING,
      pricing: isPricingResponse.data
    })
  }*/

  function setSelectedTasa(tasa) {
    setValue("tasa", tasa);
    clearErrors("tasa", {});


    setSimulator({
      type: SimulatorTypes.SET_RATE,
      tasa: tasa
    })

    if (simulator.pricing) {
      setSimulator({
        type: SimulatorTypes.SET_TASA,
        rate: tasa.id
      })
    }
    if (tasa !== undefined) {
      handleCalculateTea(parseFloat(tasa.id), 0);
    }
  }

  function selectExtract(estrato) {
    setValue("estrato", estrato);
    setSimulator({
      type: SimulatorTypes.SET_EXTRACT,
      estrato: estrato
    })
  }

  async function setSelectedState(state) {
    try {
      setIsLoading(true);
      const cities = await getCities(state.id);
      setCities(cities.data);

      setValue('departamento', state.nombre);
      setSimulator({
        type: SimulatorTypes.SET_SELECTED_STATE,
        state
      });

      const isPricingResponse = await isPricing(simulator.desk.id);
      if (!isPricingResponse.data) {
        await updateTasa(simulator.clientData.pagaduria?.id, state.id);
      }

      if (simulator.clientData.ciudad?.id) {
        cities.data.map((item) => {
          if (item.id == simulator.clientData.ciudad.id) {
            setSelectedCity(item);
          }
        });
      }


      setIsLoading(false);
      setShowState(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function setSelectedPais(pais) {
    try {
      setIsLoading(true);
      setValue('pais', pais.nombre);
      if (pais.nombre !== 'Colombia') {
        setAnotherCountry(true);
        setIsLoading(true);
        setAnotherCity(true);
        setAnotherDeparment(true);
        /*const departamentos = await getDepartamentosMundo();
        const nuevoDepartamento = {
          "id": "OTRO",
          "nivel": "DEPARTAMENTO",
          "nombre": "OTRO",
          "nacionalidad": "OTRO"
        };
        const departamentosActualizados = departamentos.data.concat(nuevoDepartamento);
        setDepartamentos(departamentosActualizados);
        const nuevaCiudad = {
          "id": "OTRO",
          "nivel": "CIUDAD",
          "nombre": "OTRO",
          "nacionalidad": "OTRO"
        };
        const ciudades = await getCiudadesMundo();
        const ciudadesActualizados = departamentos.data.concat(nuevaCiudad);
        setCiudades(ciudadesActualizados);*/
        setIsLoading(false);
      } else {
        setIsLoading(true);
        setAnotherCountry(false);
        setAnotherCity(false);
        setAnotherDeparment(false);
        const states = await getStates();
        await setStates(states.data);
        setIsLoading(false);
      }
      setSimulator({
        type: SimulatorTypes.SET_SELECTED_PAIS,
        pais
      });

      setShowPais(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function setSelectedDepartamento(state) {
    try {
      setValue('departamento', state.nombre);
      setSimulator({
        type: SimulatorTypes.SET_SELECTED_STATE,
        state
      });

      if (state.nombre == 'OTRO') {
        setAnotherDeparment(true)
      } else {
        setAnotherDeparment(false)
        setValue('departamentoNacimiento2', state.nombre)
      }

      setShowDepartamento(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function setSelectedCiudad(city) {
    try {
      setValue('ciudad', city.nombre);
      setSimulator({
        type: SimulatorTypes.SET_SELECTED_CITY,
        city
      });

      if (city.nombre == 'OTRO') {
        setAnotherCity(true)
      } else {
        setAnotherCity(false)
        setValue('ciudadNacimiento2', city.nombre)
      }

      setShowCiudad(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  function selectEducationalLevel(educationaLevel) {
    setValue("nivelEscolaridad", educationaLevel);
    clearErrors("nivelEscolaridad", {});
    setSimulator({
      type: SimulatorTypes.SET_EDUCATIONAL_LEVEL,
      nivelEscolaridad: educationaLevel
    })
    setShowEducationalLevel(false);
  }

  function selectContractType(contracttype) {
    setValue("tipoDeContrato", contracttype);
    clearErrors("tipoDeContrato", {});

    setSimulator({
      type: SimulatorTypes.SET_CONTRACT_TYPE,
      tipoContrato: contracttype
    })
    setShowContractType(false);
  }

  async function setSelectedCity(city) {
    setValue('ciudad', city.nombre);
    setSimulator({
      type: SimulatorTypes.SET_SELECTED_CITY,
      city
    });
    setShowCity(false);
  }

  function handleCalculateDate() {
    let years = calculateDate(fields.fechaNacimiento);
    setValue("edad", years);

    setSimulator({
      type: SimulatorTypes.SET_FECHA_NASCIMENTO,
      fechaNacimiento: fields.fechaNacimiento
    })
    setSimulator({
      type: SimulatorTypes.SET_YEARS_OLD_BY_DATE,
      edad: years
    })
  }

  function searchInCities(e) {
    setShowCity(true);
    setShowState(false);
    let filtered = cities.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCities(filtered);
  }

  function searchInState(e) {
    setShowState(true);
    setShowCity(false);
    let filtered = states.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredStates(filtered);
  }

  function searchInPais(e) {
    setShowPais(true);
    let filtered = paises.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredPais(filtered);
  }

  function searchInDepartamento(e) {
    setShowDepartamento(true);
    let filtered = departamentos.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredDepartamento(filtered);
  }

  function searchInCiudad(e) {
    setShowCiudad(true);
    let filtered = ciudades.filter(city => city.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredCiudad(filtered);
  }

  function setInitiarDiasIniciales() {
    setValue("diasInteresesIniciales", 120);
    clearErrors("diasInteresesIniciales", {});
  }

  function setPlazoInicial() {
    if (fields.plazo == "" && !simulator.priceValueToSolicitate.plazo) {
      setValue("plazo", 12);
      clearErrors("plazo", {});
      simulator.priceValueToSolicitate.plazo = 12;
    }
  }

  function setMontoSolicitado() {
    if (fields.monto == "" && !simulator.priceValueToSolicitate.monto) {
      setValue("monto", 2000000);
      clearErrors("monto", {});
      simulator.priceValueToSolicitate.monto = 2000000;
    }
  }


  function setIdentificationRadioChecked(radio) {
    setClientDataSearchIdentificationType(radio.value);
    if (simulator.clientData.tipoIdentificacion.value == radio.value) {
      setSimulator({
        type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
        tipoIdentificacion: radio,
        identificacion: clientDataSearchIdentification?.replaceAll('.', '')
      })
    } else {
      setSimulator({
        type: SimulatorTypes.SET_IDENTIFICATION_TYPE,
        tipoIdentificacion: radio,
        identificacion: ''
      })
      setValue('identificacion', '');
    }
  }

  async function setCompleteStep(data) {
    try {
      if (parseInt(simulator.simulation?.montoMaximoSugerido) >= parseInt(simulator.simulation?.montoTotalCredito)) {
        if (gestionPoliticas) {
          if (fields.plazo >= 12 && fields.plazo <= 144) {
            if (simulator.pricing) {
              if (simulator.priceValueToSolicitate.tipoContrato?.nombre) {
                let isBonoSocial = false;
                let responseBonoSocial = {
                  data: {
                    cumpleCondiciones: true
                  }
                }
                if ((simulator.financesData.lineaCredito.idBackend == 7 || simulator.financesData.lineaCredito.idBackend == 6)) {
                  const dataBonoSocial = {
                    remanente: parseInt(simulator.simulation?.remanenteEstimado),
                    valorDestino: fields.bonoSocial
                  }
                  isBonoSocial = true;
                  responseBonoSocial = await postCalcularBonoSocial(dataBonoSocial);
                }
                if(simulator.priceValueToSolicitate.pricingProduct.groupNumber == 10){
                  setIsLoading(false)
                  setShowModalBonoSocial(true);
                  setTittleModalBonoSocial("Le informamos que por políticas internas la solicitud de crédito de su cliente "
                  + "no es viable. Si su cliente requiere de más información, puede comunicarse con la línea telefónica de experiencia al cliente 018000184095.");
                  return;
                }
                if (responseBonoSocial.data.cumpleCondiciones || (!isBonoSocial)) {
                  data.pricingProduct = simulator.priceValueToSolicitate.pricingProduct;
                  data.nivelEscolaridad = simulator.priceValueToSolicitate.nivelEscolaridad;
                  data.tipoContrato = simulator.priceValueToSolicitate.tipoContrato;
                  data.monto = montoSolicitadoBD;
                  data.capacidadCliente = fields.capacidadCliente;
                  if (isBonoSocial) data.bonoSocial = responseBonoSocial.data;
                  setIsLoading(true);
                  setSimulator({
                    type: SimulatorTypes.SET_PRICE_VALUE_TO_SOLICITATE,
                    priceValueToSolicitate: data
                  })
                  if (simulator.clientData.pais?.nombre != 'Colombia') {
                    simulator.clientData.departamento = {
                      nombre: fields?.departamentoExpedicionExtranjero,
                      id: simulator.clientData.pais.id + ">" + fields.departamentoExpedicionExtranjero,
                    }
                    simulator.clientData.ciudad = {
                      nombre: fields.ciudadExpedicionExtranjero.toUpperCase(),
                      id: simulator.clientData.pais.id + ">" + fields.departamentoExpedicionExtranjero + ">" + fields.ciudadExpedicionExtranjero.toUpperCase(),
                    }
                  }
                  data.tasa = simulator.priceValueToSolicitate.tasa;
                  simulator.clientData.identificacion = data.identificacion;
                  setIsLoading(false);
                  setLastStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
                  setActiveStep(simulatorSteps.CLIENT_DATA);
                } else {
                  setIsLoading(false)
                  setShowModalBonoSocial(true);
                  setTittleModalBonoSocial('No cumple con las condiciones de ' + simulator.financesData.lineaCredito.nombre)
                }
              } else {
                setIsLoading(false);
                setShowModalNullContract(true);
              }
            } else {
              setIsLoading(false);
              setLastStep(simulatorSteps.PRICE_VALUE_TO_SOLICITATE);
              setActiveStep(simulatorSteps.CLIENT_DATA);
            }
          } else {
            setShowModalPlazo(true);
          }
        } else {
          setShowModalInfoError(true);
          setTitleErrorOnCalculate(gestionPoliticasMessage);
        }
      } else {
        setShowModalInfoError(true);
        setTitleErrorOnCalculate('La capacidad del cliente es inferior al valor de la cuota');
      }
      setIsLoading(false);
      setShowElement(true);
    } catch (error) {
      console.log(error)
      setIsLoading(false);
    }
  }

  async function loadClientDataForIdentification() {
    try {
      setIsLoading(true);
      var tipoIdentificacion = clientDataSearchIdentificationType;
      var identificacion = clientDataSearchIdentification?.replaceAll('.', '');
      var pagaduria = null;
      var departamento = null;
      if (!identificacion) {
        showClientDataSearchError("Ingrese un número de identificación");
      } else {
        var response = await getClientDataFull(tipoIdentificacion, identificacion);
        if (response.data) {
          setSimulator({
            type: SimulatorTypes.SET_CLIENT_DATA,
            clientData: response.data
          });
          if (response.data.tipoIdentificacion == 'CC') {
            setIdentificationRadioChecked({ id: 'CC', nombre: 'Cédula de ciudadanía', label: 'CC', value: 'CC' })
          } else {
            simulator.clientData.tipoIdentificacion = { id: 'CE', nombre: 'Cédula de extranjería', label: 'CE', value: 'CE' };
          }
          if (response.data.pagaduria) {
            setSimulator({
              type: SimulatorTypes.SET_PAYMENT_BILL,
              pagaduria: response.data.pagaduria
            });
            pagaduria = response.data.pagaduria.id;
            setSelectedPaymentBill(response.data.pagaduria)
            //setPaymentBill(response.data.pagaduria);
          }
          /* Comentado por cambio de alcance en modelo de tasas*/
          /*
          if(response.data.ciudadResidencia) {
              if(response.data.ciudadResidencia.id) {
                setSimulator({
                  type: SimulatorTypes.SET_SELECTED_CITY,
                  city: {
                    id: response.data.ciudadResidencia.id,
                    nombre: response.data.ciudadResidencia.nombre
                  }
                });
              }
              if(response.data.ciudadResidencia.departamento) {
                setSimulator({
                  type: SimulatorTypes.SET_SELECTED_STATE,
                  state: {
                    id: response.data.ciudadResidencia.departamento,
                    nombre: response.data.ciudadResidencia.departamento.split('>')[1]
                  }
                });
                departamento = response.data.ciudadResidencia.departamento;
              }
          }*/
          response = await getLastCreditByClient(response.data?.id);
          if (response.data) {
            let actividad = {
              id: response.data.actividad,
              nombre: toUpperFirst(response.data.actividad)
            }
            setSelectedActivitie(actividad);
            setSimulator({
              type: SimulatorTypes.SET_ACTIVITIE,
              actividadCliente: actividad
            });
          }
          if (!simulator.pricing) {
            updateTasa(pagaduria, departamento);
          }
        } else {
          showClientDataSearchError("No se encontraron datos para el cliente");
        }
      }
    } catch (error) {
      showClientDataSearchError("No se pudieron obtener los datos del cliente");
      console.log(error.response)
    }
    setIsLoading(false);
  }

  async function onBlurIdetification() {
    try {
      // Si ya se está ejecutando, no continuar
      if (isExecuting.current) {
        console.log("⚠️ Ya se está ejecutando la función, se cancela esta llamada");
        return;
      }
      isExecuting.current = true;
      setIsLoading(true);
      await loadClientDataForIdentificationWithOutError();
      setInvalidClient(false);
    } catch (error) {
      console.log(error);
      setInvalidClient(true);
    }finally {
      isExecuting.current = false; // marcar como terminada
    }
  }
  
  

  async function generateAutorization() {
    try {
      setIsLoading(true);
      setShowModalCambioAsesor(false)
      const req = new FormData();
      req.append('tipoIdentificacion', simulator.clientData.tipoIdentificacion?.id);
      req.append('identificacion', fields.identificacion.replaceAll('.', ''));
      req.append('idAsesor', session.idAsesor);
      req.append('data', errores);
      req.append('idOficina', simulator.desk.id);
      const response = await postGenerateAutorization(req);
      setIsLoading(false);
      setShowModalCambioAsesorEnviado(true);
    } catch (error) {
      setIsLoading(false);
    }
  }

  async function loadClientDataForIdentificationWithOutError() {
    try {
      setIsLoading(true);
      var tipoIdentificacion = clientDataSearchIdentificationType;
      var identificacion = clientDataSearchIdentification?.replaceAll('.', '');
      var pagaduria = null;
      var departamento = null;
      if (!identificacion) {
        showClientDataSearchError("Ingrese un número de identificación");
      } else {
        var response = await getClientDataFull(tipoIdentificacion, identificacion);
        response.data.pagaduria = null;
        if (!response.data.aceptacionHabeasData) {
          setShowModalInfoError(true);
          simulator.clientData.mensajeHabeasData = response.data.mensajeHabeasData;
          simulator.clientData.aceptacionHabeasData = response.data.aceptacionHabeasData;
          setTitleErrorOnCalculate(response.data.mensajeHabeasData);
          setIsLoading(false);
          return
        } else {
          if (response.data && response.data.id) {
            if (response.data.estado?.toLocaleLowerCase() == "bloqueado" || response.data.estado?.toLocaleLowerCase() == "fallecido") {
              setShowModalInfoError(true);
              setTitleErrorOnCalculate('El cliente esta bloqueado. Por favor contacta al líder o director de la oficina en tu ciudad.');
              setIsLoading(false);
              return
            }
            setSimulator({
              type: SimulatorTypes.SET_CLIENT_DATA,
              clientData: response.data
            });

            if(response.data.fechaNacimiento){
              setValue("fechaNacimiento", response.data.fechaNacimiento);
              fields.fechaNacimiento = response.data.fechaNacimiento;
              handleCalculateDate();
            }
            if (response.data.ciudadExpedicion) {
              const [pais, departamento] = response.data.ciudadExpedicion.id.split(">");
            
              setSelectedPais(paises.find(country => country.id === pais));
            
              let depto = states.find(state => state.nombre.trim().toLowerCase() === departamento.trim().toLowerCase());
              
              if (depto) {  
                setSelectedState(depto);
                
                const cities = await getCities(depto.id);
                
                setSelectedCity(cities.data.find(city => city.id === response.data.ciudadExpedicion.id));
              } else {
                console.warn("⚠️ Departamento no encontrado:", departamento);
              }
            }

            if(response.data.estrato){
              selectExtract(extracts.find(estrato => estrato.idLegado === response.data.estrato))
            }

            if (response.data.genero == 'M') {
              setGenderRadioChecked({ id: 6, nombre: "Masculino", idLegado: "M", idPricing: "M" })
            }
            if (response.data.genero == 'F') {
              setGenderRadioChecked({ id: 7, nombre: "Femenino", idLegado: "F", idPricing: "F" })
            }

            if (response.data.tipoIdentificacion == 'CC') {
              setIdentificationRadioChecked({ id: 'CC', nombre: 'Cédula de ciudadanía', label: 'CC', value: 'CC' })
            } else {
              simulator.clientData.tipoIdentificacion = { id: 'CE', nombre: 'Cédula de extranjería', label: 'CE', value: 'CE' };
            }

            response = await getLastCreditByClient(response.data?.id);

            if(response.data.actividad){
              simulator.clientData.actividadCliente = toUpperFirst(response.data?.actividad)
              const contractTypes = await getContractTypes(response.data?.actividad);
              let contractType = contractTypes.data.find(contrato => contrato.id === response.data.idTipoContrato)
              if(contractType) simulator.priceValueToSolicitate.tipoContrato = contractType.nombre;
            }

            // if (response.data.idPagaduria) {
            //   let pagaduria = paymentBill.find(pagaduria => pagaduria.id === response.data.idPagaduria)
            //   if(pagaduria) setSelectedPaymentBill(pagaduria);
            // }
           
            if (!simulator.pricing) {
              updateTasa(pagaduria, departamento);
            }

            if(response.data.nivelEducativo){
              selectEducationalLevel(educationalLevel.find(edu => edu.idLegado === response.data.nivelEducativo))
            }
          } else {
            simulator.clientData.identificacion = identificacion
            simulator.clientData.email = response.data.email
            simulator.clientData.celular = response.data.celular
            simulator.clientData.aceptacionHabeasData = response.data.aceptacionHabeasData;
            // Asignar nombres y apellidos
            simulator.clientData.primerNombre = response.data.primerNombre || '';
            simulator.clientData.segundoNombre = response.data.segundoNombre || '';
            simulator.clientData.primerApellido = response.data.primerApellido || '';
            simulator.clientData.segundoApellido = response.data.segundoApellido || '';
          }
        }
      }
    } catch (error) {
      console.log("Error");
      showClientDataSearchError("No se pudieron obtener los datos del cliente");
      console.log(error.response)
    }
    setIsLoading(false);
  }

  async function getCredits() {
    const data = {
      tipoIdentificacion: simulator.clientData.tipoIdentificacion.value,
      identificacion: fields.identificacion.replaceAll('.', '')
    }

    let dataValidation = {
      tipoIdentificacion: clientDataSearchIdentificationType,
      identificacion: clientDataSearchIdentification?.replaceAll('.', ''),
      idAsesor: session.idAsesor,
      idPagaduria: paymentBill.id,
      idLineaCredito: simulator.financesData.lineaCredito.idBackend,
    };

    const response = await validateClientAdvisorPaymentBill(dataValidation);
    if(response.data.tipo == 'VALIDACIONES_FALLIDAS_POLITICA'){
      setSelectedLineOfCredit({})
      setErrores(response.data.errores[0]);
      setShowModalCambioAsesor(true);
      return;
    }else if (response.data.tipo == 'VALIDACIONES_FALLIDAS'){
      setMessageErrorOnCalculate('');
      setSelectedLineOfCredit({})
      setTitleErrorOnCalculate(response.data.errores);
      setShowModalInfoError(true)
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const credits = await getCreditsByAdvisor(data, simulator.desk.id);
    setIsLoading(false);
    setCreditsByAcesor(credits.data);
    setIsCreditsByAcesor(true);
  }

  async function setSelectedLineOfCredit(lineOfCredit) {
    setValue("lineaCredito", lineOfCredit?.nombre);
    clearErrors("lineaCredito", []);
    setCalculate(true);
    setTotalFieldsCredit(0)
    setDisabledForm(true);

    if ((lineOfCredit?.idBackend === creditLinesBack[2].id || lineOfCredit?.idBackend === creditLinesBack[3].id) && !isCreditsByAcesor) {
      getCredits();
    } else {
      setIsLoading(false);
    }

    if (simulator.financesData.lineaCredito?.idBackend === creditLinesBack[1].id || simulator.financesData.lineaCredito?.idBackend === creditLinesBack[3].id) {
      setSimulator({
        type: SimulatorTypes.SET_DEFAULT_INPUT,
        fields: [{ id: 0, value: '' }]
      })
    }

    if (simulator.financesData.lineaCredito?.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito?.idBackend === creditLinesBack[3].id) {
      setSimulator({
        type: SimulatorTypes.SET_DEFAULT_CREDIT,
        credits: []
      })
    }

    setSimulator({
      type: SimulatorTypes.SET_LINE_OF_CREDIT,
      lineaCredito: lineOfCredit
    })

    verifyFields();
  }

  async function updateTasa(pagaduria, departamento) {
    if (pagaduria && departamento) {
      var response = await getTasasFilter(pagaduria, departamento);
      if (response.data) {
        const tasa = response.data.find(item => (item.id === simulator.priceValueToSolicitate.tasa?.id || item.id == simulator.priceValueToSolicitate.tasa));
        setSelectedTasa(tasa);
        setTasas(response.data);
      }
    }
  }



  function verifyCheckbox(checkbox) {
    let res = false;
    getListofCredits().forEach(item => {
      if (item.id === checkbox.id) {
        res = true;
        return;
      }
    });
    return res;
  }

  function toUpperFirst(str) {
    return str == '' || str == null ? str :
      str[0].toUpperCase() + (str.length > 1 ? str.substring(1).toLowerCase() : '');
  }

  function formatTasa(tasa) {
    return "" + tasa + " %";
  }

  function calculateTea(tasa) {
    return Math.ceil(((Math.pow(1 + tasa / 100, 12.0)) - 1) * 10000) / 100;
  }

  function handleCalculateTea(tasa, id) {
    const tea = calculateTea(tasa);
    setValorTea(tea);
    setValue("tea", formatTasa(tea));
    if (id == 2) {
      setValorTea(tea);
      setValue("tea", formatTasa(tea));
    }
    if (id == 1) {
      setValorTea1(tea);
      setValue("tea1", formatTasa(tea));
    }
  }

  function setGenderRadioChecked(genero) {
    setValue("genero", genero.nombre);
    setSimulator({
      type: SimulatorTypes.SET_TAKER_GENDER,
      genero: genero
    })
  }

  async function setSelectedPaymentBill(paymentBill) {
    if (!paymentBill || paymentBill.id === simulator.clientData.pagaduria?.id) {
        return; // Evita ejecutar si es el mismo valor actual o si es `null`
    }

    let data = {
        tipoIdentificacion: clientDataSearchIdentificationType,
        identificacion: clientDataSearchIdentification?.replaceAll('.', ''),
        idAsesor: session.idAsesor,
        idPagaduria: paymentBill.id,
    };

    const response = await validateClientAdvisorPaymentBill(data);
    if (response.data.tipo === 'VALIDACIONES_FALLIDAS_POLITICA') {
        setSelectedActivitie({});
        setErrores(response.data.errores[0]);
        setShowModalCambioAsesor(true);
        return;
    } else if (response.data.tipo === 'VALIDACIONES_FALLIDAS') {
        setMessageErrorOnCalculate('');
        setSelectedActivitie({});
        setTitleErrorOnCalculate(response.data.errores);
        setShowModalInfoError(true);
        setIsLoading(false);
        return;
    }

    setValue("pagaduria", paymentBill.nombre);
    clearErrors("pagaduria", {});

    if (pilotoPagaduria) {
        const response = await getActivitiesPorIdPagaduria(paymentBill.id);
        const objetoEncontrado = response.data.find(elemento => 
            elemento.nombre === simulator.clientData.actividadCliente?.nombre
        );

        if (!objetoEncontrado && simulator.clientData.actividadCliente?.id != undefined) {
            setSelectedActivitie({});
        }

        if (simulator.clientData.actividadCliente) {
            response.data.forEach(item => {
                if (simulator.clientData.actividadCliente === item.nombre) {
                    setSelectedActivitie(item);
                }
            });
        }

        setActivities(response.data);
    }

    setSimulator({
        type: SimulatorTypes.SET_PAYMENT_BILL,
        pagaduria: paymentBill
    });

    if (!simulator.pricing) {
        await updateTasa(paymentBill.id, simulator.clientData.departamento?.id);
    }

    setShowPaymentByll(false);
}

  function canUseSelectRate() {
    if (fields.plazo && fields.monto && simulator.financesData.ingresos && simulator.financesData.descuentosLey && simulator.clientData.ciudad?.nombre &&
      simulator.clientData.pagaduria?.nombre && (simulator.clientData.departamento?.nombre || fields.departamentoExpedicionExtranjero) && simulator.financesData.lineaCredito?.nombre) {
      return true;
    } else {
      return false
    }
  }

  function canUseSelectRatePricing() {
    if (fields.plazo && fields.monto && simulator.clientData.departamento?.nombre && simulator.financesData.ingresos
      && simulator.financesData.descuentosLey && simulator.clientData.ciudad?.nombre && simulator.clientData.pagaduria?.nombre && simulator.clientData.departamento?.nombre
      && simulator.clientData.genero && simulator.priceValueToSolicitate.nivelEscolaridad?.nombre && simulator.financesData.lineaCredito?.nombre) {
      return true;
    } else {
      return false
    }
  }



  function onChangeIdentification(e) {
    var identificacion = undefined;
    if (simulator.clientData.tipoIdentificacion.value === 'CE') {
      identificacion = e.target.value;
    } else {
      identificacion = handleChangeIdentification(e.target.value);
    }
    setValue('identificacion', identificacion);
    // setSimulator({
    //   type: SimulatorTypes.SET_IDENTIFICATION,
    //   identificacion: identificacion
    // }); 
    setClientDataSearchIdentification(identificacion);
    setClientDataSearchErrorVisible(false);
  }

  function showClientDataSearchError(error) {
    setClientDataSearchError(error);
    setClientDataSearchErrorVisible(true);
  }

  function searchInPaymentBill(e) {
    setShowPaymentByll(true);
    let filtered = paymentBill.filter(paymentBill => paymentBill.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredPaymentBill(filtered);
  }

  async function doSimulation() {
    setIsLoading(true);
    console.log("simulator.financesData.lineaCredito" + JSON.stringify(simulator.financesData.lineaCredito))
    
    const req = {
      idPagaduria: simulator.clientData.pagaduria?.id,
      pais: simulator.clientData.pais?.nombre,
      idLineaCredito: simulator.financesData.lineaCredito.idBackend,
      idOficina: simulator.desk.id,
      actividadCliente: simulator.clientData.actividadCliente.id,
      tasa: parseFloat(simulator.priceValueToSolicitate.tasa?.nombre.replace('% ', '')),
      plazo: parseInt(fields.plazo),
      monto: montoSolicitadoBD,
      capacidadCliente: parseInt(fields.capacidadCliente) == 0 ? null : parseInt(fields.capacidadCliente),
      diasInteresesIniciales: 120,
      ingresos: parseInt(simulator.financesData.ingresos),
      cliente: {
        identificacion: /*simulator.clientData.identificacion.replaceAll('.', '')*/fields.identificacion.replaceAll('.', ''),
        fechaNacimiento: simulator.clientData.fechaNacimiento
      },
      descuentosLey: (simulator.financesData.descuentosLey) ? parseInt(simulator.financesData.descuentosLey) : 0,
      descuentosNomina: (simulator.financesData.descuentosNomina) ? parseInt(simulator.financesData.descuentosNomina) : 0,
      carteras: [],
      departamento: simulator.clientData.pais?.nombre == 'Colombia' ? simulator.clientData.departamento?.id : (simulator.clientData.pais?.id + ">" + fields.departamentoExpedicionExtranjero),
      genero: simulator.clientData.genero.idLegado,
      nivelEducativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
      tipoContrato: simulator.priceValueToSolicitate.tipoContrato?.nombre,
      productPricing: simulator.priceValueToSolicitate.pricingProduct,
      totalActivos: fields.totalActivos,
      estrato: simulator.clientData.estrato?.nombre,
      simulador1: true,
    }

    const walletFields = simulator.financesData.fields.map(item => {
      return {
        monto: item.value
      }
    });

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.carteras = walletFields;
    }

    if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id || simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
      req.idCreditoPadre = getListofCredits().map(credito => credito.id)
    }

    /*const req2 = { ...req };
    req2.productPricing = simulator.priceValueToSolicitate.pricingProduct1;
    req2.tasa = simulator.priceValueToSolicitate.pricingProduct1?.rate;
    */
    try {
      const simulation = await postSimulation(req);
      setSimulator({
        type: SimulatorTypes.SET_SIMULATION,
        simulation: simulation.data
      })
      setMontoSolicitadoBD(simulation.data.monto)
      if(capacidadCliente === 0){
        setValue("capacidadCliente", simulation.data.capacidadAproximada);
        setCapacidadCliente(simulation.data.capacidadAproximada);
      }
      if(fields.capacidadCliente > simulation.data?.capacidadAproximada){
        setShowModalInfoError(true);
        setTitleErrorOnCalculate("El valor que estás ingresando excede la capacidad de pago del cliente.");
        setCapacidadCliente(simulation.data.capacidadAproximada);
        setShowSlider(false);
      }
      setShowSlider(true);
      setNuevoProductoLibranzas(simulation.data.isNuevoProductoLibranza);
      /*if (simulator.pricing) {
        const simulation1 = await postSimulation(req2);
        setSimulator({
          type: SimulatorTypes.SET_SIMULATION1,
          simulation1: simulation1.data
        })
      }*/
      const data = {
        term: parseInt(fields.plazo),
        amount: parseInt(simulation.data.montoTotalCredito),
        birthdate: fields.fechaNacimiento,
        identification: fields.identificacion.replaceAll('.', ''),
        idPagaduria: simulator.clientData.pagaduria?.id,
      }
      const gestionPoliticasResponse = await postGestionPoliticas(data);
      setGestionPoliticas(gestionPoliticasResponse.data.result);
      setGestionPoliticasMessage(gestionPoliticasResponse.data.message);
      if (gestionPoliticasResponse.data.result) {
        setIsLoading(false);
        setShowElement(true);
        setShowElement(false)
      } else {
        setIsLoading(false);
        setShowElement(true);
        setShowModalInfoError(true);
        setTitleErrorOnCalculate(gestionPoliticasResponse.data.message);
      }
      setShowElement(true);

      setDisabledForm(false);
    } catch (error) {
      setDisabledForm(true);
      setShowModalInfoError(false);
      console.log(error.response)
      setTitleErrorOnCalculate(error.message);
    }
    setIsLoading(false);
  }

  function getListofCredits() {
    return (simulator.financesData.credits.length === undefined) ? [simulator.financesData.credits] : simulator.financesData.credits;
  }

  function verifyFields() {
    let { ingresos, descuentosNomina, descuentosLey } = fields;

    setSimulator({
      type: SimulatorTypes.SET_VALUE_FIELDS_OF_FINANCES,
      ingresos,
      descuentosNomina,
      descuentosLey
    })
  }


  function validateIngresos() {
    let { ingresos, descuentosNomina, descuentosLey } = fields;
    if (Number(ingresos) < Number(descuentosNomina) + Number(descuentosLey)) {
      setTitleErrorIngresos("Campos de descuentos no deben ser superiores a los ingresos.");
      setShowModalInfoIngresos(true);
      setDisabledForm(true);
      return false;
    }
    return true;
  }

  function deleteFieldFromStore(field) {
    let fields = simulator.financesData.fields;
    fields = fields.filter(item => item.id !== field.id);

    setSimulator({
      type: SimulatorTypes.SET_FIELDS,
      fields
    })
  }

  function calculateData() {
    if (!simulator.clientData.aceptacionHabeasData) {
      setShowModalInfoError(true);
      setTitleErrorOnCalculate(simulator.clientData.mensajeHabeasData);
      setIsLoading(false);
      return;
    }
    if (validateIngresos()) {
      doSimulation();
      setShowClientData(false);
    }

  }

  async function updatePlazo() {
    if (!simulator.clientData.aceptacionHabeasData) {
      setShowModalInfoError(true);
      setTitleErrorOnCalculate(simulator.clientData.mensajeHabeasData);
      setIsLoading(false);
      return;
    }
    if (validateIngresos()) {
      await getProductPricing();
      await doSimulation();
      setShowClientData(false);
    }

  }

  function setCreditToStore(credit) {
    if (credit.idPagaduria === simulator.clientData.pagaduria?.id) {
      const newCredit = {
        id: credit.id,
        numeroRadicacion: credit.numeroRadicacion,
        saldoAlDia: credit.saldoAlDia
      }
      const filtered = getListofCredits().filter(credito => credito.id === credit.id);
      if (filtered.length > 0) {
        const newCreditList = getListofCredits().filter(credito => credito.id !== credit.id);
        setSimulator({
          type: SimulatorTypes.SET_CREDIT_CHECKBOX,
          credits: newCreditList
        });
      } else {
        setSimulator({
          type: SimulatorTypes.SET_CREDIT_CHECKBOX,
          credits: [...getListofCredits().filter(credito => credito.id !== undefined), newCredit]
        });
      }

      verifyFields()
    } else {
      setShowModalInfoError(true)
      setMessageErrorOnCalculate('');
      setTitleErrorOnCalculate('Crédito no pertenece a la misma pagaduría seleccionada');
    }

  }

  function modalErrorResetDefault() {
    setShowModalInfoError(false)
    setMessageErrorOnCalculate('');
    setTitleErrorOnCalculate('Error en el servicio OnboardingServices');
  }



  function onChangeField(name, key, value) {
    let fields = simulator.financesData.fields;
    setValue(name, value);

    let totalSum = 0;
    fields.forEach(item => {
      if (item.id === key) {
        item.value = value
      }
      totalSum += item.value;
    });

    setTotalFieldsCredit(totalSum);

    setSimulator({
      type: SimulatorTypes.SET_FIELDS,
      fields
    })

    verifyFields()
  }

  useEffect(() => {
    initializedStateComponent();
    return () => {
      setTasas([]);
      setFilteredPaymentBill([]);
    }
  }, []);

  useEffect(() => {
    if (simulator.financesData.ingresos && simulator.financesData.ingresos !== '0' && simulator.financesData.lineaCredito.idBackend && simulator.priceValueToSolicitate.tasa?.nombre && fields.identificacion && !invalidClient) {
      if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id) {
        if (simulator.financesData.fields[0].value > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id) {
        if (getListofCredits().length > 0 && creditsByAcesor.length > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if (simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id) {
        if (simulator.financesData.fields[0].value > 0 && getListofCredits().length > 0 | !creditsByAcesor.length) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if ((simulator.financesData.lineaCredito.idBackend == 7 || simulator.financesData.lineaCredito.idBackend == 6)) {
        if (fields.bonoSocial != "") {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      }
      else {
        setCalculate(false)
      }
    } else {
      setCalculate(true);
    }

  }, [simulator.financesData, simulator.priceValueToSolicitate.tasa, fields.identificacion, invalidClient, fields.bonoSocial, simulator.financesData.lineaCredito.idBackend])


  function canUseForm() {
    if (simulator.desk.id) {
      return true;
    } else {
      return false
    }
  }

  async function getProductPricing() {
    if (simulator.desk.id) {
      let validarLineaBonoSocial = (simulator.financesData.lineaCredito.idBackend == 6 || simulator.financesData.lineaCredito.idBackend == 7);
      const req = {
        genero: simulator.clientData.genero.idPricing,
        departamento: simulator.clientData.pais?.nombre == 'Colombia' ? simulator.clientData.departamento?.nombre : fields.departamentoExpedicionExtranjero,
        nivel_educativo: simulator.priceValueToSolicitate.nivelEscolaridad?.idLegado,
        id_pagaduria: simulator.clientData.pagaduria?.id,
        fecha_nacimiento: fields.fechaNacimiento,
        tipo_contrato: simulator.priceValueToSolicitate.tipoContrato?.nombre,
        nombre_pagaduria: simulator.clientData.pagaduria?.nombre,
        total_activos: fields.totalActivos || 0,
        descuentos_nomina: simulator.financesData.descuentosNomina || 0,
        bono_social: validarLineaBonoSocial,
        identificacion: fields.identificacion.replaceAll('.', ''),
        actividad_cliente: simulator.clientData.actividadCliente?.nombre,
        ingresos_mensuales: parseInt(simulator.financesData.ingresos) || 0,
        descuentos_ley: parseInt(simulator.financesData.descuentosLey) || 0,
        plazo: parseInt(fields.plazo),
        idLineaCredito: simulator.financesData.lineaCredito.idBackend
      }
      setSimulatorOne(true);
      const responseOnePricing = await getTasasPricing(req, simulatorOne);
      const rates = responseOnePricing.data.rates;
      const ratesWithSymbol = rates.map(rate => ({
        id: rate,
        nombre: rate + '%',
      }))
      setTasas(ratesWithSymbol);
      const tasaObjeto = { id: responseOnePricing.data.rate, nombre: (responseOnePricing.data.rate + '%') }
      setSelectedTasa(tasaObjeto);

      setSimulator({
        type: SimulatorTypes.SET_PRODUCT,
        pricingProduct: {
          rate: responseOnePricing.data.rate,
          suretyBond: responseOnePricing.data.suretyBond,
          creditStudy: responseOnePricing.data.creditStudy,
          productGroupId: responseOnePricing.data.productGroupId,
          deterioration: responseOnePricing.data.deterioration,
          rates: responseOnePricing.data.rates,
          groupNumber: responseOnePricing.data.groupNumber,
          deteriorationAdjust: responseOnePricing.data.deteriorationAdjust,
          outRange: responseOnePricing.data.outRange,
          enabled: responseOnePricing.data.enabled,
          message: responseOnePricing.data.message,
          hc: responseOnePricing.data.hc
        }
      })
      //const response = await getTasasPricingAndCifin(req);

      /*response.data.map((item) => {
        if (item.id == 2) {
          const tasaObjeto = { id: item.rate, nombre: (item.rate + '%') }
          setSelectedTasa(tasaObjeto);
          setSimulator({
            type: SimulatorTypes.SET_PRODUCT,
            pricingProduct: {
              rate: item.rate,
              suretyBond: item.suretyBond,
              creditStudy: item.creditStudy,
              productGroupId: item.productGroupId,
              deterioration: item.deterioration,
              rates: item.rates,
              groupNumber: item.groupNumber,
              deteriorationAdjust: item.deteriorationAdjust,
              outRange: item.outRange,
              enabled: item.enabled,
              message: item.message
            }
          })
          if (!item.enabled) {
            setMessageErrorProduct(response.data.message);
            setShowModalInfoProduct(true);
            setTitleErrorProduct(response.data.message);
          }
          handleCalculateTea(tasaObjeto.id, item.id)
        } else {
          const tasaObjeto = { id: item.rate, nombre: (item.rate + '%') };
          setSimulator({
            type: SimulatorTypes.SET_PRODUCT1,
            pricingProduct1: {
              rate: item.rate,
              suretyBond: item.suretyBond,
              creditStudy: item.creditStudy,
              productGroupId: item.productGroupId,
              deterioration: item.deterioration,
              rates: item.rates,
              groupNumber: item.groupNumber,
              deteriorationAdjust: item.deteriorationAdjust,
              outRange: item.outRange,
              enabled: item.enabled,
              message: item.message
            }
          })
          if (!item.enabled) {
            setMessageErrorProduct(item.message);
            setShowModalInfoProduct(true);
            setTitleErrorProduct('Vigencia del grupo ' + item.groupNumber);
          }
          handleCalculateTea(tasaObjeto.id, item.id);
        }
      })*/

      //setValue("groupNumber",response.data.groupNumber);

    }
  }

  async function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});
    if (activitie.id != undefined) {
      const contractTypes = await getContractTypes(activitie.id);
      const objetoEncontrado = contractTypes.data.find((elemento) => {
        return elemento.nombre === simulator.priceValueToSolicitate.tipoContrato?.nombre;
      });
      if (!objetoEncontrado) {
        selectContractType({});
      }
      if (simulator.priceValueToSolicitate.tipoContrato) {
        contractTypes.data.map((item) => {
          if (item.nombre == simulator.priceValueToSolicitate.tipoContrato) {
            selectContractType(item);
          }
        });
      }
      setContractsType(contractTypes.data);
    } else {
      selectContractType({});
    }
    setSimulator({
      type: SimulatorTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    })
  }

  useEffect(() => {
    if (simulator.pricing && simulator.clientData.genero && (simulator.clientData.departamento?.nombre || fields.departamentoExpedicionExtranjero) && simulator.priceValueToSolicitate.nivelEscolaridad?.nombre
      && simulator.clientData.edad && simulator.clientData.pagaduria?.nombre && simulator.financesData.descuentosNomina && simulator.priceValueToSolicitate.tipoContrato?.nombre 
      && simulator.clientData.actividadCliente?.nombre &&  simulator.financesData.lineaCredito.idBackend) {
      if (simulator.clientData.aceptacionHabeasData) {
        getProductPricing();
      } else {
        setShowModalInfoError(true);
        setTitleErrorOnCalculate(simulator.clientData.mensajeHabeasData);
        setIsLoading(false);
      }

    }
  }, [simulator.clientData, simulator.financesData, simulator.priceValueToSolicitate.nivelEscolaridad, simulator.priceValueToSolicitate.tipoContrato, 
    fields.totalActivos, fields.departamentoExpedicionExtranjero,simulator.clientData.actividadCliente?.nombre, simulator.financesData.lineaCredito.idBackend ])


  useEffect(() => {
    setShowElement(false);
  }, [simulator.clientData, simulator.financesData, simulator.priceValueToSolicitate, fields.totalActivos])

  useEffect(() => {
    if (simulator.financesData.lineaCredito.idBackend == 3 || simulator.financesData.lineaCredito.idBackend == 5) {
      getCredits();
    }
  }, [simulator.financesData.lineaCredito])

  useEffect(() => {
    setSimulator({
      type: SimulatorTypes.SET_CREDIT_CHECKBOX,
      credits: []
    });
  }, [simulator.clientData.pagaduria?.nombre]);

  useEffect(() => {
    if (simulator.clientData.fechaNacimiento && simulator.clientData.estrato?.nombre && simulator.financesData.ingresos && fields.identificacion) {
      setLineaCreditoBonoSocial();
    }
  }, [simulator.clientData.fechaNacimiento, simulator.clientData.estrato?.nombre, simulator.financesData.ingresos, fields.identificacion])

  function onBlurIngresos() {
    verifyFields();
    if (simulator.clientData.fechaNacimiento && simulator.clientData.estrato?.nombre && simulator.financesData.ingresos && fields.identificacion) {
      setLineaCreditoBonoSocial();
    }
  }

  async function setLineaCreditoBonoSocial() {
    setIsLoading(true);
    const data = {
      ingresos: parseInt(simulator.financesData.ingresos),
      numeroIdentificacion: fields.identificacion.replaceAll('.', ''),
      fechaNacimiento: simulator.clientData.fechaNacimiento,
      estrato: simulator.clientData.estrato?.idLegado
    }
    const bonoSocial = await postIsBonoSocial(data);
    if ((simulator.financesData.lineaCredito.idBackend == 6 || simulator.financesData.lineaCredito.idBackend == 7) && (!bonoSocial.data.result)) {
      setSelectedLineOfCredit({})
    }
    if (!(bonoSocial.data.result && piloto.isBonoSocial)) {
      const filteredLineasDeCredito = lineasDeCredito.filter(item => item.id !== 6 && item.id !== 7);
      setLineasDeCredito(filteredLineasDeCredito);
    } else {
      setLineasDeCredito(lineasDeCreditoBD);
    }
    setIsLoading(false);
  }


  return (
    <FormTemplate
      idForm="price-value-to-solicitate-step-page"
      idButton="new-simulation"
      labelButton="Nueva simulación"
      activeStep="1/2"
      stepLabel="Valores crédito a solicitar"
      actionHeaderButton={setShowModal}>
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <ClientDataHead onClick={() => setShowClientData(!showClientData)}>
          <ClientDataHeadLabel>Información del usuario</ClientDataHeadLabel>
          {showClientData && <IoIosArrowDown size={25} style={{ marginRight: '15px' }}></IoIosArrowDown>}
          {!showClientData && <IoIosArrowUp size={25} style={{ marginRight: '15px' }}></IoIosArrowUp>}
        </ClientDataHead>

        <div style={showClientData ? {} : { display: 'none' }}>
          <FormRow col="3">
            <Select
              disabled={!canUseForm()}
              error={errors.tipoDocumento}
              setShow={setShowTipoDocumentos}
              show={showTipoDocumentos}
              defaultValue={simulator.clientData.tipoIdentificacion?.nombre}
              setSelected={setIdentificationRadioChecked}
              list={tipoDocumento}
              placeholder="Seleccionar..."
              label="Tipo de documento"
              name="tipoIdentificacion"
              id="tipoIdentificacion"
              register={register({ required: "Este dato es obligatorio" })}
            />
            {/* <RadioButtonForm
              label="Tipo de documento"
              setIdentificationRadioChecked={setIdentificationRadioChecked}
              defaultValue="CC"
              selected={simulator.clientData.tipoIdentificacion}
              name="tipoIdentificacion"
              id="tipoIdentificacion"
              register={register({ required: "Este dato es obligatorio" })}
              radios={[
                { label: 'CC', value: 'CC' }
              ]} />*/}
            <Controller
              name="identificacion"
              control={control}
              value={simulator.clientData.identificacion}
              disabled={!canUseForm()}
              render={() => (
                <InputDefault
                  name="identificacion"
                  label="Número de documento de identidad"
                  register={register({
                    required: "Este dato es obligatorio",
                    pattern: {
                      value: /^\d+(\.\d+)*$/,
                      message: "Error en el número, ingresa uno válido",
                    }
                  })}
                  id="identificacion"
                  error={errors.identificacion}
                  maxLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.max : identificationType.cc.max}
                  minLength={simulator.clientData.tipoIdentificacion.value === 'CE' ? identificationType.ce.min : identificationType.ce.min}
                  onChange={onChangeIdentification}
                  onBlur={() => onBlurIdetification()}
                />
              )}
            />
            <ClientDataSearchColumn>
              <ClientDataSearchError visible={clientDataSearchErrorVisible}>{clientDataSearchError}</ClientDataSearchError>
              <DefaultSmallButtonBuscar type="button" id="load-client-data" onClick={onBlurIdetification}> <img src={Buscar} alt="button"></img> </DefaultSmallButtonBuscar>
            </ClientDataSearchColumn>

          </FormRow>
          <FormRow col="3">
            <Select
              disabled={!canUseForm()}
              error={errors.genero}
              setShow={setShowGeneros}
              show={showGeneros}
              defaultValue={simulator.clientData.genero?.nombre}
              setSelected={setGenderRadioChecked}
              list={generos}
              placeholder="Seleccionar..."
              label={<div>Género <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-genero' /></div>}
              name="genero"
              id="genero"
              register={register({ required: "Este dato es obligatorio" })}
            />
            <Tooltip
              id='tooltip-genero'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
              </TooltipTitle>
              <TooltipContent>
                El Género debe corresponder al señalado en la identificación.
              </TooltipContent>
            </Tooltip>
            {/* 
            <RadioButtonForm
              disabled={!canUseForm()}
              label="Género"
              setIdentificationRadioChecked={setGenderRadioChecked}
              defaultValue="M"
              selected={simulator.clientData.genero}
              name="genero"
              id="genero"
              register={register({ required: "Este dato es obligatorio" })}
              radios={[
                { label: 'M', value: 'M' },
                { label: 'F', value: 'F' }
              ]} />*/}


          </FormRow>
          <FormRow col="3">
            <SearchField
              label="País de Expedición Documento"
              name="pais"
              id="pais"
              disabled={!canUseForm()}
              show={showPais}
              list={filteredPais}
              defaultValue={simulator.clientData.pais?.nombre}
              selectField={setSelectedPais}
              searchInList={searchInPais}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.pais} />
            {!anotherCountry &&
              <SearchField
                label="Departamento de Expedición Documento"
                name="departamento"
                id="departamento"
                disabled={!canUseForm()}
                show={showState}
                list={filteredStates}
                defaultValue={simulator.clientData.departamento?.nombre}
                selectField={setSelectedState}
                searchInList={searchInState}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                error={errors.departamento} />
            }
            {/*simulator.clientData.pais?.nombre !== 'Colombia' &&
            <SearchField
              label="Departamento de Expedición Documento"
              name="departamento"
              id="departamento"
              disabled={!canUseForm()}
              show={showDepartamento}
              list={filteredDepartamento}
              defaultValue={simulator.clientData.departamento?.nombre}
              selectField={setSelectedDepartamento}
              searchInList={searchInDepartamento}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.departamento} />
            */}
            {anotherCountry &&
              <Controller
                type="text"
                as={InputDefault}
                control={control}
                error={errors.Departamento}
                register={register({ required: "Este dato es obligatorio" })}
                label="Departamento de Expedición Documento"
                name="departamentoExpedicionExtranjero"
                id="departamentoExpedicionExtranjero"
                value={simulator?.departamento} />
            }
            {/*simulator.clientData.pais?.nombre !== 'Colombia' &&
          <SearchField
              label="Ciudad o Municipio de Expedición Documento"
              name="ciudad"
              id="ciudad"
              show={showCiudad}
              list={filteredCiudad}
              defaultValue={simulator.clientData.ciudad?.nombre}
              selectField={setSelectedCiudad}
              searchInList={searchInCiudad}
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Buscar..."
              error={errors.city} /> 
          */}
            {!anotherCountry &&
              <SearchField
                label="Ciudad o Municipio de Expedición Documento"
                name="ciudad"
                id="ciudad"
                show={showCity}
                list={filteredCities}
                defaultValue={simulator.clientData.ciudad?.nombre}
                selectField={setSelectedCity}
                searchInList={searchInCities}
                register={register({ required: "Este dato es obligatorio" })}
                placeholder="Buscar..."
                error={errors.city}
                disabled={!simulator.clientData.departamento} />
            }
            {anotherCountry &&
              <Controller
                type="text"
                as={InputDefault}
                control={control}
                error={errors.Departamento}
                register={register({ required: "Este dato es obligatorio" })}
                label="Ciudad o Municipio de Expedición Documento"
                name="ciudadExpedicionExtranjero"
                id="ciudadExpedicionExtranjero"
                value={simulator?.departamento} />
            }

          </FormRow>
          {simulator.pricing && <>
            <FormRow col="3">
              <InputDate
                aria-required
                disabled={!canUseForm()}
                type="date"
                label="Fecha de nacimiento"
                name="fechaNacimiento"
                register={register({ required: "Este dato es obligatorio" })}
                id="fechaNacimiento"
                onBlur={handleCalculateDate}
                error={errors.fechaNacimiento}
                />
              <Controller
                as={InputDefault}
                control={control}
                label="Edad cliente"
                name="edad"
                register={register}
                id="yearsold"
                error={errors.edad}
                readOnly={true}
                value={simulator.clientData.edad} />
              <Select
                disabled={!canUseForm()}
                error={errors.nivelEscolaridad}
                setShow={setShowEducationalLevel}
                show={showEducationalLevel}
                defaultValue={simulator.priceValueToSolicitate.nivelEscolaridad?.nombre}
                setSelected={selectEducationalLevel}
                list={educationalLevel}
                placeholder="Seleccionar..."
                label="Nivel de escolaridad"
                name="nivelEscolaridad"
                id="nivelEscolaridad"
                register={register({ required: "Este dato es obligatorio" })}
              />
            </FormRow>
            <FormRow col="3">
              <SearchField
                disabled={!canUseForm()}
                label="Pagaduría"
                name="pagaduria"
                id="pagaduria"
                show={showPaymentBill}
                list={filteredPaymentBill}
                defaultValue={simulator.clientData.pagaduria?.nombre}
                selectField={setSelectedPaymentBill}
                searchInList={searchInPaymentBill}
                register={register({ required: "Este dato es obligatorio" })}
                error={errors.pagaduria}
                placeholder="Buscar..." />

              <Select
                error={errors.actividadCliente}
                setShow={setShowActivity}
                show={showActivity}
                defaultValue={simulator.clientData.actividadCliente?.nombre}
                setSelected={setSelectedActivitie}
                list={activities}
                placeholder={simulator.clientData.pagaduria?.nombre ? "Seleccionar..." : "Seleccione una pagaduria..."}
                label="Actividad"
                name="actividadCliente"
                id="actividadCliente"
                register={register({ required: "Este dato es obligatorio" })}
                disabled={!simulator.clientData.pagaduria?.nombre} />
              <Select
                error={errors.tipoContrato}
                setShow={setShowContractType}
                show={showContractType}
                defaultValue={simulator.priceValueToSolicitate.tipoContrato?.nombre}
                setSelected={selectContractType}
                list={contractTypes}
                placeholder={simulator.clientData.actividadCliente?.nombre ? "Seleccionar..." : "Seleccione una actividad..."}
                label="Tipo de contrato / Pensión"
                name="tipoDeContrato"
                id="tipoDeContrato"
                register={register({ required: "Este dato es obligatorio" })}
                disabled={!simulator.clientData.actividadCliente?.nombre}
              />
            </FormRow>
          </>}

          {!simulator.pricing &&
            <>
              <FormRow col="3">
                <SearchField
                  disabled={!canUseForm()}
                  label="Pagaduría"
                  name="pagaduria"
                  id="pagaduria"
                  show={showPaymentBill}
                  list={filteredPaymentBill}
                  defaultValue={simulator.clientData.pagaduria?.nombre}
                  selectField={setSelectedPaymentBill}
                  searchInList={searchInPaymentBill}
                  register={register({ required: "Este dato es obligatorio" })}
                  error={errors.pagaduria}
                  placeholder="Buscar..." />
                <InputIntl
                  disabled={!canUseForm()}
                  id="ingresos"
                  label="Total ingresos mensuales"
                  error={errors.ingresos}
                  name="ingresos"
                  defaultValue={simulator.financesData.ingresos}
                  setValue={setValue}
                  currencyConfig={currencyMoney}
                  register={register({
                    required: "Este dato es obligatorio",
                    min: {
                      value: 1,
                      message: "Este dato es obligatorio"
                    }
                  })}
                  onBlur={() => verifyFields()} />
                <InputIntl
                  disabled={!canUseForm()}
                  id="descuentosNomina"
                  label={<div>Otros Descuentos<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-nomina' /></div>}
                  error={errors.descuentosNomina}
                  name="descuentosNomina"
                  defaultValue={simulator.financesData.descuentosNomina || 0}
                  setValue={setValue}
                  currencyConfig={currencyMoney}
                  register={register({
                    min: {
                      value: 0,
                      message: "Este dato es obligatorio"
                    }
                  })}
                  onBlur={() => verifyFields()} />
              </FormRow>
              <Tooltip
                id='tooltip-descuentos-nomina'
                effect="solid"
                place='top'
                border
                multiline
                textColor='#05443D'
                borderColor='#25BBAB'>
                <TooltipTitle>
                  Total otros descuentos de nómina
                </TooltipTitle>
                <TooltipContent>
                  Deducciones que se aplican al cliente cuando se le efectúa su pago laboral.
                </TooltipContent>
              </Tooltip>
            </>
          }


          {simulator.pricing &&
            <>
              <FormRow col="3">
                <Select
                  disabled={!canUseForm()}
                  error={errors.estrato}
                  setShow={setShowExtracts}
                  show={showExtracts}
                  defaultValue={simulator.clientData.estrato?.nombre}
                  setSelected={selectExtract}
                  list={extracts}
                  placeholder="Seleccionar..."
                  label="Estrato"
                  name="estrato"
                  id="estrato"
                  register={register({ required: "Este dato es obligatorio" })}
                />
                <InputIntl
                  disabled={!canUseForm()}
                  id="totalactives"
                  label="Total de Activos"
                  error={errors.totalActivos}
                  name="totalActivos"
                  defaultValue={simulator.priceValueToSolicitate.totalActivos}
                  setValue={setValue}
                  currencyConfig={currencyMoney}
                  register={register({
                    required: "Este dato es obligatorio",
                    min: {
                      value: 1,
                      message: "Este dato es obligatorio"
                    }
                  })} />
                <InputIntl
                  disabled={!canUseForm()}
                  id="ingresos"
                  label="Total ingresos mensuales"
                  error={errors.ingresos}
                  name="ingresos"
                  defaultValue={simulator.financesData.ingresos}
                  setValue={setValue}
                  currencyConfig={currencyMoney}
                  register={register({
                    required: "Este dato es obligatorio",
                    min: {
                      value: 1,
                      message: "Este dato es obligatorio"
                    }
                  })}
                  onBlur={() => onBlurIngresos()}
                />

              </FormRow>

            </>
          }
          <FormRow col="3">
            <InputIntl
              disabled={!canUseForm()}
              id="descuentosNomina"
              label={<div>Total otros descuentos de nómina<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-nomina' /></div>}
              error={errors.descuentosNomina}
              name="descuentosNomina"
              defaultValue={simulator.financesData.descuentosNomina || 0}
              setValue={setValue}
              currencyConfig={currencyMoney}
              register={register({
                min: {
                  value: 0,
                  message: "Este dato es obligatorio"
                }
              })}
              onBlur={() => verifyFields()} />

            <InputIntl
              disabled={!canUseForm()}
              id="descuentosLey"
              label={<div>Total descuentos de ley<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-ley' /></div>}
              error={errors.descuentosLey}
              name="descuentosLey"
              defaultValue={simulator.financesData.descuentosLey}
              setValue={setValue}
              currencyConfig={currencyMoney}
              onBlur={() => verifyFields()}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 0,
                  message: "Este dato es obligatorio"
                }
              })}
            />
            <Select
              error={errors.lineaCredito}
              setShow={setShowLineOfCredit}
              show={showLineOfCredit}
              defaultValue={simulator.financesData.lineaCredito.nombre}
              setSelected={setSelectedLineOfCredit}
              list={lineasDeCredito}
              placeholder={"Seleccionar..."}
              label="Modalidad de crédito"
              name="lineaCredito"
              id="lineaCredito"
              register={register({ required: "Este dato es obligatorio" })}
              disabled={!simulator.clientData.pagaduria?.nombre} />
            <Tooltip
              id='tooltip-descuentos-nomina'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Total otros descuentos de nómina
              </TooltipTitle>
              <TooltipContent>
                Deducciones que se aplican al cliente cuando se le efectúa su pago laboral.
              </TooltipContent>
            </Tooltip>
          </FormRow>
          {!simulator.pricing &&
            <FormRow col='3'>
              <Select
                error={errors.tasa}
                setShow={setShowTasa}
                show={showTasa}
                defaultValue={simulator.priceValueToSolicitate.tasa?.nombre}
                setSelected={setSelectedTasa}
                list={tasas}
                placeholder={canUseSelectRate() ? "Seleccionar..." : "Ingrese todos los datos para continuar..."}
                label="Tasa NMV %"
                name="tasa"
                id="tasa"
                disabled={!canUseSelectRate()}
                register={register({ required: "Este dato es obligatorio" })} />
            </FormRow>
          }
          {/* <FormRow col='3'>
            <InputIntl
              disabled={!canUseForm()}
              id="amount"
              label="Monto solicitado"
              error={errors.monto}
              name="monto"
              defaultValue={simulator.priceValueToSolicitate.monto}
              setValue={setValue}
              currencyConfig={currencyMoney}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 1,
                  message: "Este dato es obligatorio"
                }
              })} />
          </FormRow>*/}
          {/*
          <FormRow col="2">
          <InputDefault
            disabled={!canUseForm()}
            aria-required
            type="number"
            label="Plazo en meses"
            name="plazo"
            register={register({
              required: "Este dato es obligatorio",
              validate: {
                minValue: (value) => parseFloat(value) >= 12 || 'El dato debe estar entre 12 y 144',
                maxValue: (value) => parseFloat(value) <= 144 || 'El dato debe estar entre 12 y 144',
              },
            })}
            placeholder="Meses"
            id="plazo"
            error={errors.plazo}
          />
           <InputIntl
            disabled={!canUseForm()}
            id="amount"
            label="Monto solicitado"
            error={errors.monto}
            name="monto"
            defaultValue={simulator.priceValueToSolicitate.monto}
            setValue={setValue}
            currencyConfig={currencyMoney}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 1,
                message: "Este dato es obligatorio"
              }
            })} />
        </FormRow>
          */}

          <FormRowInvisible>
            <InputDefault
              aria-required
              type="number"
              label="Días intereses Iniciales"
              name="diasInteresesIniciales"
              register={register({ required: "Este dato es obligatorio" })}
              placeholder="Días"
              id="diasInteresesIniciales"
              error={errors.diasInteresesIniciales}
              maxLength="3"
              readOnly={true}
            />
            {/* <InputDefault
              disabled={!canUseForm()}
              aria-required
              type="number"
              label="Plazo en meses"
              name="plazo"
              register={register({
                required: "Este dato es obligatorio",
                validate: {
                  minValue: (value) => parseFloat(value) >= 12 || 'El dato debe estar entre 12 y 144',
                  maxValue: (value) => parseFloat(value) <= 144 || 'El dato debe estar entre 12 y 144',
                },
              })}
              placeholder="Meses"
              id="plazo"
              error={errors.plazo}
            />*/}
          </FormRowInvisible>
          {(simulator.financesData.lineaCredito.idBackend == 7 || simulator.financesData.lineaCredito.idBackend == 6) &&
            <FormRow>
              <InputIntl
                disabled={!canUseForm()}
                id="bonoSocial"
                label={simulator.financesData.lineaCredito.idBackend == 6 ? 'Valor destinado a educación' : 'Valor destinado a actividades productivas'}
                error={errors.bonoSocial}
                name="bonoSocial"
                defaultValue={simulator.priceValueToSolicitate?.bonoSocial}
                setValue={setValue}
                currencyConfig={currencyMoney}
                register={register({
                  required: "Este dato es obligatorio",
                  min: {
                    value: 1,
                    message: "Este dato es obligatorio"
                  }
                })} />
            </FormRow>}
          {simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id ||
            simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id ? (
            <FinancesDataCreditLine>
              <FinancesDataCreditLineTitle>Créditos activos</FinancesDataCreditLineTitle>
              <FinancesDataCreditCheckboxContainerLine>
                {!isLoading ? (
                  creditsByAcesor.length ? (
                    creditsByAcesor.map((item, key) => (
                      <FinancesDataCreditCheckboxContainer>
                        <InputCheckbox onClick={() => setCreditToStore(item)}
                          checked={verifyCheckbox(item)}
                          value={item.numeroRadicacion} />
                        <FinancesDataCreditCheckboxContainerText><FinancesDataCreditCheckboxContainerTitle>Pagaduría:</FinancesDataCreditCheckboxContainerTitle>{item.pagaduria.nombre}</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerText>Saldo al día:</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerSaldo>$ {formatPrice(parseInt(item.saldoAlDia))}</FinancesDataCreditCheckboxContainerSaldo>
                        <FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerTitle>Cuota a retanquear:</FinancesDataCreditCheckboxContainerTitle>
                        <FinancesDataCreditCheckboxContainerTitle>$ {formatPrice(parseInt(item.cuota))}</FinancesDataCreditCheckboxContainerTitle>
                        </FinancesDataCreditCheckboxContainerText>
                      </FinancesDataCreditCheckboxContainer>
                    ))
                  ) : (
                    simulator.financesData.lineaCredito.idBackend === creditLinesBack[2].id ? (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos, selecciona otra modalidad de crédito</FinancesDataNoCredit>
                    ) : (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos</FinancesDataNoCredit>
                    )
                  )) : ''}
              </FinancesDataCreditCheckboxContainerLine>
              {!isLoading && creditsByAcesor.length ? (
                <SaldoTotalRecoger>
                  <SaldoTotalRecogerContainer>Saldo total a recoger</SaldoTotalRecogerContainer>
                  <SaldoTotalRecogerContainer>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</SaldoTotalRecogerContainer>
                </SaldoTotalRecoger>
              ) : ''}
            </FinancesDataCreditLine>
          ) : ''}
          {simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
            simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id ? (
            <>
              <FinancesDataFieldTitle>Valores consolidación de deudas</FinancesDataFieldTitle>
              <FinancesDataFieldContainer>
                {simulator.financesData.fields.map((item, key) => (
                  <FinancesDataFieldContent key={key}>
                    <FinancesDataFieldInputTitle>
                      <FinancesDataFieldTitleValorLabel>Valor {key + 1}</FinancesDataFieldTitleValorLabel>
                      {key > 0 && <FinancesDataFieldTitleValorDeleteItem onClick={() => deleteFieldFromStore(item)}>Eliminar Valor</FinancesDataFieldTitleValorDeleteItem>}
                    </FinancesDataFieldInputTitle>
                    <InputIntl
                      id={`chekbox${key}`}
                      key={key}
                      register={register}
                      onBlur={() => verifyFields()}
                      currencyConfig={currencyMoney}
                      name={`field${item.id}`}
                      defaultValue={item.value}
                      onChange={(event, value, maskedValue) => onChangeField(`field${item.id}`, key, value)}
                    />
                  </FinancesDataFieldContent>
                ))}
              </FinancesDataFieldContainer>
            </>
          ) : ''}

          <ClientDataButtoCalculate align={simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
            simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id}>
            {simulator.financesData.lineaCredito.idBackend === creditLinesBack[1].id ||
              simulator.financesData.lineaCredito.idBackend === creditLinesBack[3].id
              ? <ClientDataAddButton type="button" onClick={() => setSimulator({ type: SimulatorTypes.ADD_FIELD, field: { id: simulator.financesData.fields.length, value: '' } })} id="add-field">+ Añadir valor</ClientDataAddButton> : ''}
            <ClientDataButtoCalculateButton type="button" disabled={calculate} onClick={() => calculateData()} id="calculate">Confirmar Datos</ClientDataButtoCalculateButton>
          </ClientDataButtoCalculate>
        </div>
        <div style={showElement ? { display: 'grid' } : { display: 'none' }}>
          <FormRowBorder>
            {showSlider && 
            <Slider
            id="capacidadCliente"
            name="capacidadCliente"
            setValue={setValue}
            min={0}
            defaultValue={capacidadCliente}
            max={simulator.simulation?.capacidadAproximada ? simulator.simulation?.capacidadAproximada : capacidadCliente}
            doSimulation={calculateData}
            label={<div>¿Quieres cambiar la capacidad?<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-capacidad' /></div>}
            register={register({ required: "Este dato es obligatorio" })}
          />}
            
            <SliderInt
              min={12}
              max={144}
              id="plazo"
              name="plazo"
              defaultValue={simulator.priceValueToSolicitate.plazo}
              doSimulation={updatePlazo}
              setValue={setValue}
              label={<div>¿Quieres cambiar el plazo?<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-plazo' /></div>}
              register={register({ required: "Este dato es obligatorio" })}
            />
          </FormRowBorder>
          <Tooltip
            id='tooltip-plazo'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Plazo en meses
            </TooltipTitle>
            <TooltipContent>
              Cantidad de tiempo que un cliente tiene para pagar un crédito.
            </TooltipContent>
          </Tooltip>
          
          <Tooltip
            id='tooltip-capacidad'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
            Capacidad de pago
            </TooltipTitle>
            <TooltipContent>
            Modifica la capacidad del cliente de acuerdo al rango indicado.
            </TooltipContent>
          </Tooltip>
        </div>


        {/*showElement && !simulator.pricing && <>
          <ClientDataTotal>
            <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
            <ClientDataTotalData>{formatTasa(valorTea)}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataTotal>
            <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
            <ClientDataTotalData>{simulator.simulation.diasInteresesIniciales}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataTotal>
            <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
            <ClientDataTotalData>$ {simulator.simulation.capacidadAproximada ? formatPrice(parseInt(simulator.simulation.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
          </ClientDataTotal>
          <ClientDataMontoTotal>
            <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
            <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</ClientDataTotalData>
            <ClientDataTotalDataMin>Tasa: {simulator.priceValueToSolicitate.tasa?.nombre}</ClientDataTotalDataMin>
            <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
            <ClientDataTotalDataMinBlack><b>*</b> Monto máximo a aprobar sujeto a capacidad de endeudamiento y políticas de Excelcredit.</ClientDataTotalDataMinBlack>
          </ClientDataMontoTotal>
          <FormFooterRigth>
            <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
          </FormFooterRigth>
            </>*/}

        {/*showElement && simulator.pricing && <div style={{ display: 'none' }}>
          <FormRow col="2">
            <ClientDataTotal>
              <ClientDataTotalTitle>PERFIL DE RIESGO OPCIÓN 1
                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasabaja' />
              </ClientDataTotalTitle>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>PERFIL DE RIESGO OPCIÓN 2
                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-tasaalta' />
              </ClientDataTotalTitle>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
              <ClientDataTotalData>{formatTasa(valorTea)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Tasa E.A</ClientDataTotalTitle>
              <ClientDataTotalData>{formatTasa(valorTea1)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
              <ClientDataTotalData>{simulator.simulation.diasInteresesIniciales}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>DIA DE INTERESES INICIALES</ClientDataTotalTitle>
              <ClientDataTotalData>{simulator.simulation1?.diasInteresesIniciales}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
              <ClientDataTotalData>$ {simulator.simulation.capacidadAproximada ? formatPrice(parseInt(simulator.simulation.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataTotal>
              <ClientDataTotalTitle>Capacidad aproximada</ClientDataTotalTitle>
              <ClientDataTotalData>$ {simulator.simulation1?.capacidadAproximada ? formatPrice(parseInt(simulator.simulation1?.capacidadAproximada)) : formatPrice(0)}</ClientDataTotalData>
            </ClientDataTotal>
            <ClientDataMontoTotal>
              <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
              <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation.montoMaximoSugerido))}</ClientDataTotalData>
              <ClientDataTotalDataMin>Tasa NMV: {simulator.simulation.productPricing?.rate.toFixed(2)}%</ClientDataTotalDataMin>
              <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
              <ClientDataTotalDataMinBlack><b>*</b> Monto máximo a aprobar sujeto a capacidad de endeudamiento y políticas de Excelcredit.</ClientDataTotalDataMinBlack>
            </ClientDataMontoTotal>
            <ClientDataMontoTotal>
              <ClientDataTotalTitle>MONTO MÁXIMO SUGERIDO<b>*</b></ClientDataTotalTitle>
              <ClientDataTotalData>${formatPrice(parseInt(simulator.simulation1?.montoMaximoSugerido))}</ClientDataTotalData>
              <ClientDataTotalDataMin>Tasa NMV: {simulator.simulation1?.productPricing?.rate.toFixed(2)}%</ClientDataTotalDataMin>
              <ClientDataTotalDataMinBlack>Plazo a {fields.plazo} Meses</ClientDataTotalDataMinBlack>
              <ClientDataTotalDataMinBlack><b>*</b> Monto máximo a aprobar sujeto a capacidad de endeudamiento y políticas de Excelcredit.</ClientDataTotalDataMinBlack>
            </ClientDataMontoTotal>
          </FormRow>
          <FormFooterRigth>
            <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
          </FormFooterRigth>
          <Tooltip
            id='tooltip-tasaalta'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 2
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo negativo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>
          <Tooltip
            id='tooltip-tasabaja'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 1
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo positivo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>
        </div>*/}
        {showElement && !simulator.pricing && <>
          <div>
            <StepFourContent>
              <StepFourHeader>
                <StepFourHeaderTitle>
                  <StepFourHeaderInfo>Monto máximo sugerido: ${formatPrice(parseInt(simulator.simulation?.montoMaximoSugerido))}
                  </StepFourHeaderInfo>
                </StepFourHeaderTitle>
              </StepFourHeader>
              <StepFourColumn>
                <FormRow>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={colors.grayLight}>
                      <img src={singPost} size={28}></img>
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Tasa EA</H6>
                      <H6 color={colors.textPrimary} semibold>{formatTasa(valorTea)}</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={colors.grayLight}>
                      <img src={singPost} size={28}></img>
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Tasa NMV</H6>
                      <H6 color={colors.textPrimary} semibold>{simulator.priceValueToSolicitate.tasa?.nombre}%</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                </FormRow>

                <FormRow>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={colors.grayLight}>
                      <img src={singPost} size={28}></img>
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Capacidad aproximada</H6>
                      <H6 color={colors.textPrimary} semibold>$ {simulator.simulation.capacidadAproximada ? formatPrice(parseInt(simulator.simulation.capacidadAproximada)) : formatPrice(0)}</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={colors.grayLight}>
                      <IoWalletOutline color={colors.textPrimary} size={28} />
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Cuota corriente</H6>
                      <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation?.cuotaCorriente))}</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                </FormRow>
                <FormRow>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={parseInt(simulator.simulation?.montoMaximoSugerido) < parseInt(simulator.simulation?.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                      <BsChevronBarUp color={colors.white} size={28} />
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Valor total crédito</H6>
                      <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation?.montoTotalCredito))}</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                  <StepFourResultItem>
                    <StepFourResultItemIcon background={colors.grayLight}>
                      <BiBasket color={colors.textPrimary} size={28} />
                    </StepFourResultItemIcon>
                    <StepFourResultItemInfo>
                      <H6 color={colors.textPrimary}>Remanente estimado</H6>
                      <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation?.remanenteEstimado))}</H6>
                    </StepFourResultItemInfo>
                  </StepFourResultItem>
                </FormRow>
              </StepFourColumn>
              <StepFourColumn>
                <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
                <StepFourDisplayValues>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>Estudio crédito + IVA</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.estudioCreditoMasIVA))}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>
                      Valor de la fianza
                      <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                    </StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {simulator.simulation?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  {/* <StepFourDisplayValuesRow>
        <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
      </StepFourDisplayValuesRow> */}
                </StepFourDisplayValues>
                {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
                <StepFourDisplayValues>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.gmf))}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>
                      Valor compras a girar
                      <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                    </StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                  <StepFourDisplayValuesRow>
                    <StepFourDisplayValuesRowValue>
                      Prima anticipada de seguro
                      <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                    </StepFourDisplayValuesRowValue>
                    <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
                  </StepFourDisplayValuesRow>
                </StepFourDisplayValues>
              </StepFourColumn>
            </StepFourContent>
          </div>
          <StepFourFooter>
            <StepFourFooterRightSide>
              <StepFourDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</StepFourDisplayValuesRowValue>
            </StepFourFooterRightSide>
          </StepFourFooter>
          <FormFooterRigth>
            <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
          </FormFooterRigth>
          <Tooltip
            id='tooltip-prima'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Prima anticipada de seguro
            </TooltipTitle>
            <TooltipContent>
              Seguro de vida destinado a respaldar el pago de la obligación crediticia en caso de muerte o pérdida de la capacidad laboral total o permanente del titular del crédito, el cual se cobra por anticipado y cubre los primeros 24 meses.
            </TooltipContent>
          </Tooltip>

          <Tooltip
            id='tooltip-fianza'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Valor de la fianza
            </TooltipTitle>
            <TooltipContent>
              Figura que cubre la obligación en caso tal de que el cliente incumpla con sus pagos, de acuerdo a condiciones del servicio.
            </TooltipContent>
          </Tooltip>

          <Tooltip
            id='tooltip-compras'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Valor compras a girar
            </TooltipTitle>
            <TooltipContent>
              Corresponde al valor de las compras de cartera.
            </TooltipContent>
          </Tooltip>

          <Tooltip
            id='tooltip-tasaalta'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 2
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo negativo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>

          <Tooltip
            id='tooltip-tasabaja'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Opción 1
            </TooltipTitle>
            <TooltipContent>
              Perfil de riesgo positivo con la mejor tasa del grupo al que queda asignado.
            </TooltipContent>
          </Tooltip>

        </>}
        {showElement && simulator.pricing &&
          <>
            <StepFourHeaderInfo>Hola, apreciado comercial <br />
              De acuerdo con los datos previos que ingresaste, la simulación de tu crédito es:
            </StepFourHeaderInfo>
            <FormRow col="1">
              <div>
                <StepFourContent>
                  <FormRow col="2">
                    <StepFourColumn>
                      {nuevoProductoLibranzas &&
                      <div>
                        <FormRow>
                        <StepFourResultItem>
                          <StepFourResultBigItemIcon background={parseInt(simulator.simulation?.montoMaximoSugerido) < parseInt(simulator.simulation?.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                            <BsChevronBarUp color={colors.white} size={32} />
                          </StepFourResultBigItemIcon>
                          <StepFourResultItemInfo>
                            <H5 color={colors.textPrimary}> <b>Valor total crédito</b>
                              <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-valorTotalCredito' />
                            </H5>
                            <H5 color={colors.textPrimary} bold><b>$ {formatPrice(parseInt(simulator.simulation?.montoTotalCredito))}</b></H5>
                          </StepFourResultItemInfo>
                        </StepFourResultItem>
                        <StepFourResultItem>
                          <StepFourResultBigItemIcon background={colors.grayLight}>
                            <BiBasket color={colors.textPrimary} size={32} />
                          </StepFourResultBigItemIcon>
                          <StepFourResultItemInfo>
                            {nuevoProductoLibranzas ?
                              <H5 color={colors.textPrimary}> <b>Remanente</b>
                              <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-remanante' />
                              </H5>
                              :
                              <H6 color={colors.textPrimary}>Remanente estimado</H6>
                            }

                            <H5 color={colors.textPrimary} bold><b>$ {formatPrice(parseInt(simulator.simulation?.remanenteEstimado))}</b></H5>
                          </StepFourResultItemInfo>
                        </StepFourResultItem>
                      </FormRow>
                      <FormRow>
                          <StepFourResultItem>
                            <StepFourResultItemIcon background={colors.grayLight}>
                              <BiBasket color={colors.textPrimary} size={28} />
                            </StepFourResultItemIcon>
                            <StepFourResultItemInfo>
                              <StepFourResultItemInfo>
                                <H6 color={colors.textPrimary}>Días período de incorporación
                                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-diasPeriodoGracia' />
                                </H6>
                                <H6 color={colors.textPrimary} semibold>{simulator.simulation?.diasInteresesIniciales} días</H6>
                              </StepFourResultItemInfo>
                            </StepFourResultItemInfo>
                          </StepFourResultItem>
                          <StepFourResultItem>
                            <StepFourResultItemIcon background={colors.grayLight}>
                              <img src={singPost} size={28}></img>
                            </StepFourResultItemIcon>
                            <StepFourResultItemInfo>
                              <StepFourResultItemInfo>
                                <H6 color={colors.textPrimary}>Tarifa seguro vida
                                </H6>
                                <H6 color={colors.textPrimary} semibold>${formatPrice(parseInt(simulator.simulation?.tarifaSeguro))}</H6>
                              </StepFourResultItemInfo>
                            </StepFourResultItemInfo>
                          </StepFourResultItem>
                        </FormRow>
                        <Tooltip
                  id='tooltip-diasInteresesIniciales'
                  effect="solid"
                  place='top'
                  border
                  multiline
                  textColor='#05443D'
                  borderColor='#25BBAB'>
                  <TooltipTitle>
                    Días periodo de gracia
                  </TooltipTitle>
                  <TooltipContent>
                    Corresponde a la Pagaduría y los tiempos de incorporación según la línea de crédito.
                  </TooltipContent>
                </Tooltip>
                      </div>
                        
                      }
                      <StepFourHeader>
                        <StepFourHeaderTitle>
                          { false && (nuevoProductoLibranzas ?
                            <StepFourHeaderInfo>
                              Valor total crédito sugerido: ${formatPrice(parseInt(simulator.simulation?.montoMaximoSugerido))}*
                              <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-valorTotalCreditoSugerido' />
                            </StepFourHeaderInfo>
                            :
                            <StepFourHeaderInfo>Monto máximo sugerido: ${formatPrice(parseInt(simulator.simulation?.montoMaximoSugerido))}*
                            </StepFourHeaderInfo>)
                          }

                        </StepFourHeaderTitle >
                      </StepFourHeader>


                      <FormRow>
                        <StepFourResultItem>
                          <StepFourResultItemIcon background={colors.grayLight}>
                            <img src={singPost} size={28}></img>
                          </StepFourResultItemIcon>
                          <StepFourResultItemInfo>
                            <H6 color={colors.textPrimary}>Tasa EA</H6>
                            <H6 color={colors.textPrimary} semibold>{formatTasa(valorTea)}</H6>
                          </StepFourResultItemInfo>
                        </StepFourResultItem>
                        <StepFourResultItem>
                          <StepFourResultItemIcon background={colors.grayLight}>
                            <img src={singPost} size={28}></img>
                          </StepFourResultItemIcon>
                          <StepFourResultItemInfo>
                            <H6 color={colors.textPrimary}>Tasa NMV</H6>
                            <H6 color={colors.textPrimary} semibold>{simulator.simulation?.productPricing?.rate.toFixed(2)}%</H6>
                          </StepFourResultItemInfo>
                        </StepFourResultItem>
                      </FormRow>

                      <FormRow>
                        <StepFourResultItem>
                          <StepFourResultItemIcon background={colors.grayLight}>
                            <IoWalletOutline color={colors.textPrimary} size={28} />
                          </StepFourResultItemIcon>
                          <StepFourResultItemInfo>
                            {nuevoProductoLibranzas ?
                              <H6 color={colors.textPrimary}>Cuota corriente + Seguro</H6>
                              :
                              <H6 color={colors.textPrimary}>Cuota Corriente</H6>
                            }
                            <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation?.cuotaCorriente))}</H6>
                          </StepFourResultItemInfo>
                        </StepFourResultItem>
                      </FormRow>
                      
                    </StepFourColumn>
                    <StepFourColumn style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                      <div style={{ width: '100%' }}>
                        <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
                        <StepFourDisplayValues>
                          {nuevoProductoLibranzas && <>
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>
                                Valor fianza
                                <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                              </StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {simulator.simulation?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>

                            {(simulator.financesData.lineaCredito.idBackend == 3 || simulator.financesData.lineaCredito.idBackend == 5) &&
                              <div>
                                {/** 
                                <StepFourDisplayValuesRow>
                                  <StepFourDisplayValuesRowValue>Valor fianza crédito(s) padre</StepFourDisplayValuesRowValue>
                                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorFianzaPadres))}</StepFourDisplayValuesRowValue>
                                </StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRow>
                                  <StepFourDisplayValuesRowValue>Valor fianza neta</StepFourDisplayValuesRowValue>
                                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorFianzaNeta))}</StepFourDisplayValuesRowValue>
                                </StepFourDisplayValuesRow>*/}
                                <StepFourDisplayValuesRow>
                                  <StepFourDisplayValuesRowValue>Valor retanqueo</StepFourDisplayValuesRowValue>
                                  <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</StepFourDisplayValuesRowValue>
                                </StepFourDisplayValuesRow>
                                {/* <StepFourDisplayValuesRow>
                       <StepFourDisplayValuesRowValue>Valor Retanqueo padre(s) neto</StepFourDisplayValuesRowValue>
                       <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) - simulator.simulation?.primaNoConsumidaCreditoPadre || 0)}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow> */}
                              </div>}
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor intereses período de incorporación</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor seguro período de incorporación</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorSegurosIniciales))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                            {(simulator.financesData.lineaCredito.idBackend == 6 || simulator.financesData.lineaCredito.idBackend == 7) &&
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>Valor Educación o Actividades productivas</StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(fields.bonoSocial))}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                            }
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor consolidación de deudas y saneamiento
                              </StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.gmf))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                          </>}


                          {!nuevoProductoLibranzas && <>
                            <StepFourDisplayValues>
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>
                                  Valor de la fianza
                                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                                </StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {simulator.simulation?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                              {/* <StepFourDisplayValuesRow>
        <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
      </StepFourDisplayValuesRow> */}
                            </StepFourDisplayValues>
                            {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
                            <StepFourDisplayValues>
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.gmf))}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>
                                  Valor compras a girar
                                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                                </StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRow>
                                <StepFourDisplayValuesRowValue>
                                  Prima anticipada de seguro
                                  <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                                </StepFourDisplayValuesRowValue>
                                <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
                              </StepFourDisplayValuesRow>
                            </StepFourDisplayValues>
                          </>}




                          {/* <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      
                       <StepFourDisplayValuesRow>
        <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
      </StepFourDisplayValuesRow> */}
                        </StepFourDisplayValues>
                        {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
                        {/*
                    <StepFourDisplayValues>
                      
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>
                          Valor compras a girar
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                        </StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>
                          Prima anticipada de seguro
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                        </StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      {simulator.financesData.lineaCredito.idBackend == 1 &&
                      <div>
                      <StepFourDisplayValues>
                      
                     
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Prima No Devengada Crédito(s) Padre</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.primaNoConsumidaCreditoPadre))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Prima Neta de Seguro</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation?.primaNetaSeguro))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      </StepFourDisplayValues>
                      </div>}
                      </StepFourDisplayValues>*/ }
                      </div>
                    </StepFourColumn>
                  </FormRow>
                </StepFourContent>
              </div>
              <div style={{ display: 'none' }}>
                <StepFourContent>
                  {nuevoProductoLibranzas &&
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <BiBasket color={colors.textPrimary} size={28} />
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        <StepFourResultItemInfo>
                          <H6 color={colors.textPrimary}>Días período de incorporación
                            <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-diasPeriodoGracia' />
                          </H6>
                          <H6 color={colors.textPrimary} semibold>{simulator.simulation1?.diasInteresesIniciales} días</H6>
                        </StepFourResultItemInfo>
                      </StepFourResultItemInfo>
                      <Tooltip
                  id='tooltip-diasInteresesIniciales'
                  effect="solid"
                  place='top'
                  border
                  multiline
                  textColor='#05443D'
                  borderColor='#25BBAB'>
                  <TooltipTitle>
                    Días periodo de gracia
                  </TooltipTitle>
                  <TooltipContent>
                    Corresponde a la Pagaduría y los tiempos de incorporación según la línea de crédito.
                  </TooltipContent>
                </Tooltip>
                    </StepFourResultItem>
                  }

                  <StepFourHeader>
                    <StepFourHeaderTitle>
                      {false && (nuevoProductoLibranzas ?
                        <StepFourHeaderInfo>
                          Valor total crédito sugerido: ${formatPrice(parseInt(simulator.simulation1?.montoMaximoSugerido))}*
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-valorTotalCreditoSugerido' />
                        </StepFourHeaderInfo>
                        :
                        <StepFourHeaderInfo>Monto máximo sugerido: ${formatPrice(parseInt(simulator.simulation1?.montoMaximoSugerido))}*
                        </StepFourHeaderInfo>)
                      }
                    </StepFourHeaderTitle>
                  </StepFourHeader>
                  <FormRow>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <img src={singPost} size={28}></img>
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        <H6 color={colors.textPrimary}>Tasa EA</H6>
                        <H6 color={colors.textPrimary} semibold>{formatTasa(valorTea1)}</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <img src={singPost} size={28}></img>
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        <H6 color={colors.textPrimary}>Tasa NMV</H6>
                        <H6 color={colors.textPrimary} semibold>{simulator.simulation1?.productPricing?.rate.toFixed(2)}%</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                  </FormRow>
                  <FormRow>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <img src={singPost} size={28}></img>
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        <H6 color={colors.textPrimary}>Capacidad aproximada</H6>
                        <H6 color={colors.textPrimary} semibold>$ {simulator.simulation1?.capacidadAproximada ? formatPrice(parseInt(simulator.simulation1?.capacidadAproximada)) : formatPrice(0)}</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <IoWalletOutline color={colors.textPrimary} size={28} />
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        {nuevoProductoLibranzas ?
                          <H6 color={colors.textPrimary}>Cuota corriente + Seguro</H6>
                          :
                          <H6 color={colors.textPrimary}>Cuota Corriente</H6>
                        }
                        <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1?.cuotaCorriente))}</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                  </FormRow>

                  <FormRow>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={parseInt(simulator.simulation1?.montoMaximoSugerido) < parseInt(simulator.simulation1?.montoTotalCredito) ? colors.bgDanger : colors.bgSecondary}>
                        <BsChevronBarUp color={colors.white} size={28} />
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        <H6 color={colors.textPrimary}>Valor total crédito
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-valorTotalCredito' /></H6>
                        <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1?.montoTotalCredito))}</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                    <StepFourResultItem>
                      <StepFourResultItemIcon background={colors.grayLight}>
                        <BiBasket color={colors.textPrimary} size={28} />
                      </StepFourResultItemIcon>
                      <StepFourResultItemInfo>
                        {nuevoProductoLibranzas ?
                        <>
                        <H6 color={colors.textPrimary}>Remanente</H6>
                        <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-remanante' /></>
                          :
                          <H6 color={colors.textPrimary}>Remanente estimado</H6>
                        }
                        <H6 color={colors.textPrimary} semibold>$ {formatPrice(parseInt(simulator.simulation1?.remanenteEstimado))}</H6>
                      </StepFourResultItemInfo>
                    </StepFourResultItem>
                  </FormRow>

                  <StepFourColumn>
                    <StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>
                    {nuevoProductoLibranzas && <>
                      <StepFourDisplayValues>

                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>
                            Valor fianza
                            <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                          </StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {simulator.simulation1?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation1?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>

                        {(simulator.financesData.lineaCredito.idBackend == 3 || simulator.financesData.lineaCredito.idBackend == 5) &&
                          <div>
                            {/** 
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor fianza crédito(s) padre</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorFianzaPadres))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor fianza neta</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorFianzaNeta))}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>*/}
                            <StepFourDisplayValuesRow>
                              <StepFourDisplayValuesRowValue>Valor retanqueo</StepFourDisplayValuesRowValue>
                              <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</StepFourDisplayValuesRowValue>
                            </StepFourDisplayValuesRow>
                            {/* <StepFourDisplayValuesRow>
                       <StepFourDisplayValuesRowValue>Valor Retanqueo padre(s) neto</StepFourDisplayValuesRowValue>
                       <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) - simulator.simulation1?.primaNoConsumidaCreditoPadre || 0)}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow> */}
                          </div>}
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>Valor intereses período de incorporación</StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>Valor seguro período de incorporación</StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorSegurosIniciales))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        {(simulator.financesData.lineaCredito.idBackend == 6 || simulator.financesData.lineaCredito.idBackend == 7) &&
                          <StepFourDisplayValuesRow>
                            <StepFourDisplayValuesRowValue>Valor Educación o Actividades productivas</StepFourDisplayValuesRowValue>
                            <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(fields.bonoSocial))}</StepFourDisplayValuesRowValue>
                          </StepFourDisplayValuesRow>
                        }
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>Valor consolidación de deudas y saneamiento
                          </StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>


                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.gmf))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                      </StepFourDisplayValues>
                    </>}
                    {!nuevoProductoLibranzas && <>
                      <StepFourDisplayValues>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>
                            Valor de la fianza
                            <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                          </StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {simulator.simulation1?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation1?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        {/* <StepFourDisplayValuesRow>
        <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
      </StepFourDisplayValuesRow> */}
                      </StepFourDisplayValues>
                      {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
                      <StepFourDisplayValues>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>GMF (4 X 1.000)</StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.gmf))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>
                            Valor compras a girar
                            <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                          </StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRow>
                          <StepFourDisplayValuesRowValue>
                            Prima anticipada de seguro
                            <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                          </StepFourDisplayValuesRowValue>
                          <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
                        </StepFourDisplayValuesRow>
                      </StepFourDisplayValues>
                    </>}

                    {/* 
                        
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Valor intereses iniciales (CxC)</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>
                          Valor de la fianza
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-fianza' />
                        </StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {simulator.simulation1?.valorFianza !== 'null' ? formatPrice(parseInt(simulator.simulation1?.valorFianza)) : formatPrice(0)}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      {/* <StepFourDisplayValuesRow>
        <StepFourDisplayValuesRowValue>Interés de fianza</StepFourDisplayValuesRowValue>
        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation.valorInteresesIniciales))}</StepFourDisplayValuesRowValue>
      </StepFourDisplayValuesRow> */}

                    {/*<StepFourDisplayResultLabel>Descuentos</StepFourDisplayResultLabel>*/}
                    {/* 
                    <StepFourDisplayValues>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>
                          Valor compras a girar
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-compras' />
                        </StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorComprasSaneamientos))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>
                          Prima anticipada de seguro
                          <InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-prima' />
                        </StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.primaAnticipadaSeguro))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      {simulator.financesData.lineaCredito.idBackend === 3 &&
                      <div>
                        <StepFourDisplayValues>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Estudio Crédito Padre</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorEstudioCreditoPadre))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Estudio Crédito Neto</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorEstudioCreditoNeto))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Valor Fianza Crédito(s) Padre</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.valorFianzaPadres))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Valor Fianza Neta</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.totalFianza))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Prima No Devengada Crédito(s) Padre</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.primaNoConsumidaCreditoPadre))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      <StepFourDisplayValuesRow>
                        <StepFourDisplayValuesRowValue>Prima Neta de Seguro</StepFourDisplayValuesRowValue>
                        <StepFourDisplayValuesRowValue>$ {formatPrice(parseInt(simulator.simulation1?.primaNetaSeguro))}</StepFourDisplayValuesRowValue>
                      </StepFourDisplayValuesRow>
                      </StepFourDisplayValues>
                      </div>}
                    </StepFourDisplayValues>*/}
                  </StepFourColumn>
                </StepFourContent>
              </div>
            </FormRow>
            <StepFourFooter>
              <StepFourFooterRightSide>
                {nuevoProductoLibranzas ?
                  <StepFourDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</StepFourDisplayValuesRowValue>
                  :
                  <StepFourDisplayValuesRowValue><b>*</b> Los valores reflejados pueden variar dependiendo de la capacidad de endeudamiento, a la verificación de la documentación y políticas de crédito de la compañía.</StepFourDisplayValuesRowValue>
                }

              </StepFourFooterRightSide>
            </StepFourFooter>
            <FormFooterRigth>
              <SecondaryLargeButton col="flex-end" type="submit" id="submit">Continuar </SecondaryLargeButton>
            </FormFooterRigth>
            <Tooltip
              id='tooltip-prima'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Prima anticipada de seguro
              </TooltipTitle>
              <TooltipContent>
                Seguro de vida destinado a respaldar el pago de la obligación crediticia en caso de muerte o pérdida de la capacidad laboral total o permanente del titular del crédito, el cual se cobra por anticipado y cubre los primeros 24 meses.
              </TooltipContent>
            </Tooltip>

            <Tooltip
              id='tooltip-fianza'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor de la fianza
              </TooltipTitle>
              <TooltipContent>
                Figura que cubre la obligación en caso tal de que el cliente incumpla con sus pagos, de acuerdo a condiciones del servicio.
              </TooltipContent>
            </Tooltip>

            <Tooltip
              id='tooltip-compras'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor compras a girar
              </TooltipTitle>
              <TooltipContent>
                Corresponde al valor de las compras de cartera.
              </TooltipContent>
            </Tooltip>

            <Tooltip
              id='tooltip-tasaalta'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Opción 2
              </TooltipTitle>
              <TooltipContent>
                Perfil de riesgo negativo con la mejor tasa del grupo al que queda asignado.
              </TooltipContent>
            </Tooltip>

            <Tooltip
              id='tooltip-tasabaja'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Opción 1
              </TooltipTitle>
              <TooltipContent>
                Perfil de riesgo positivo con la mejor tasa del grupo al que queda asignado.
              </TooltipContent>
            </Tooltip>
            <Tooltip
              id='tooltip-diasPeriodoGracia'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Días periodo de incorporación
              </TooltipTitle>
              <TooltipContent>
                Corresponde a la Pagaduría y los tiempos de incorporación según la modalidad de crédito.
              </TooltipContent>
            </Tooltip>

            <Tooltip
              id='tooltip-valorTotalCredito'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor total crédito
              </TooltipTitle>
              <TooltipContent>
                Valor proyectado a partir de la capacidad. Asesor comercial sobre este valor se paga su comisión.
              </TooltipContent>
            </Tooltip>

            <Tooltip
            id='tooltip-monto'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
              Monto máximo a desembolsar
            </TooltipTitle>
            <TooltipContent>
            Valor máximo de acuerdo a la capacidad máxima del cliente.
            </TooltipContent>
          </Tooltip>

          <Tooltip
            id='tooltip-remanante'
            effect="solid"
            place='top'
            border
            multiline
            textColor='#05443D'
            borderColor='#25BBAB'>
            <TooltipTitle>
            Remanente
            </TooltipTitle>
            <TooltipContent>
            Valor generado según la capacidad indicada por el cliente, que puede no ser la máxima.
            </TooltipContent>
          </Tooltip>

            <Tooltip
              id='tooltip-valorTotalCreditoSugerido'
              effect="solid"
              place='top'
              border
              multiline
              textColor='#05443D'
              borderColor='#25BBAB'>
              <TooltipTitle>
                Valor total crédito sugerido
              </TooltipTitle>
              <TooltipContent>
                Valor máximo del monto sugerido de acuerdo a la capacidad.
              </TooltipContent>
            </Tooltip>

          </>
        }
        <Tooltip
          id='tooltip-descuentos-ley'
          effect="solid"
          place='top'
          border
          multiline
          textColor='#05443D'
          borderColor='#25BBAB'>
          <TooltipTitle>
            Total descuentos de ley
          </TooltipTitle>
          <TooltipContent>
            Deducciones que se aplican al cliente por aportes a salud y pensión.
          </TooltipContent>
        </Tooltip>

      </Form>

      <ModalInfo
        open={showModalInfoIngresos}
        setShowModal={setShowModalInfoIngresos}
        title={titleErrorIngresos}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoError}
        setShowModal={modalErrorResetDefault}
        title={titleErrorOnCalculate}
        description={messageErrorOnCalculate}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoProduct}
        setShowModal={setShowModalInfoProduct}
        title={titleErrorProduct}
        description={messageErrorProduct}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalNullContract}
        setShowModal={setShowModalNullContract}
        title='Es necesario seleccionar el tipo de contrato'
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalBonoSocial}
        setShowModal={setShowModalBonoSocial}
        title={tittleModalBonoSocial}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalPlazo}
        setShowModal={setShowModalPlazo}
        title="El plazo seleccionado no se encuentra en el rango permitido: es entre 12 y 144 meses."
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalAction
        open={showModalCambioAsesor}
        setShowModal={setShowModalCambioAsesor}
        actionLabelFunctionUpButton='Si, enviar solicitud'
        actionFunctionUpButton={() => generateAutorization()}
        actionLabelFunctionDownButton='Cancelar Solicitud'
        actionFunctionDownButton={() => setShowModalCambioAsesor(false)}
        title={"Estimado asesor "+session.name+","}
        description={<>En este momento no tienes autorización para iniciar la gestión con el cliente. Sin embargo, puedes solicitar un cambio de asesor.
          <br></br>¿Deseas enviar la solicitud de cambio de asesor ahora?</>}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} />} />
      <ModalAction
        open={showModalCambioAsesorEnviado}
        setShowModal={setShowModalCambioAsesorEnviado}
        title="Hemos recibido tu solicitud de cambio de asesor."
        description="En las próximas 24 horas, recibirás un correo electrónico con la respuesta a tu solicitud."
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsCheck size={32} color={colors.white} />} />
      {isLoading && <Loader />}

    </FormTemplate>

  )
}

export default PriceValueToSolicitatePage
